/* Component Dependencies */
var propertyRecordsTemplate = require('templates/s2-propertyRecords.hbs');
var multiRatePropertyRecordsTemplate = require('templates/propertyRecords-V2.hbs');
var propertyRecordsGroupSearchTemplate = require('templates/propertyRecords-groupSearch.hbs');
var propertyRecordsDestinationTemplate = require('templates/propertyRecords-destination.hbs');
var propertyRecordsHotelQuickviewTemplate = require('templates/propertyRecords-hotelQuickView.hbs');
var propertyRecordsMultiRateHotelQuickviewTemplate = require('templates/propertyRecords-hotelQuickView-V2.hbs');
var propertyRecordsGroupSearchHQVTemplate = require('templates/propertyRecords-groupSearchHQV.hbs');
var propertyRecordsCarouselTemplate = require('templates/propertyRecords-carousel.hbs');
var AriesComponent = require('libs/aries-component');
var PageTakeover = require('libs/pageTakeover');
var ResponsiveUtils = require('utils/responsiveUtils');
var localStorage = require('local-storage-fallback');
var $ = require('jquery');
var Constants = require('libs/constants');
var Widget = require('libs/widget-loader');
var Loader = require('libs/loader');
var ScrollBarHandler = require('libs/scrollbar');
var GoogleApi = require('libs/google-api');
var MapHandler = require('libs/google-map-handler');
var MapConfig = require('libs/googleMapConfig');
var baiduCluster = require('libs/baidumaps/map-cluster-normal');
var baiduInfoWindow = require('libs/baidumaps/info-window.js');
var getSymbolFromCurrency = require('currency-symbol-map');
var MapPlacesFilters = require('./js/mapPlacesFilters.js');
var Popup = require('libs/popup');
var GeoLocationHandler = require('libs/geolocation-handler');
var jsGoogleApiWrapper = require('js-google-api-wrapper');
var DomUtilities = require('utils/dom-utilities');
var LoadingIndicator = require('utils/loading-indicator');
var Cookies = require('libs/cookies');
require('libs/jquery.dotdotdot');


/**
 * Property Records Component, primarly used in Search Results.
 * This component displays the property records returned for a search results
 */
AriesComponent.create({
  type: 'propertyRecords',
  subscribe: {
    'GOOGLE_MAP_MARKER_EVENTS': 'mapMarkerEventsHandler',
    'PROPERTY_RECORDS_SWITCH_VIEW': 'setView',
    'GLOBAL_RENDER': 'setContextWrapperBox',
    'STICKY_SCROLL_TOP': 'setContextWrapperBox',
    'SEARCH_FILTER_VISIBLE': 'hidePropertyRecords',
    'SEARCH_FILTER_HIDDEN': 'showPropertyRecords',
    'GROUP_RFP_REMOVE_HOTEL': 'removeRfpFromPropertyRecords',
    'GROUP_RFP_ADD_HOTEL': 'addSelectedPropertySuccess',
    'GROUP_RFP_TILE_PRESENT': 'makePaginationSticky',
    'MAP_BOTTOM_AREA_ADJUST' : 'setContextWrapperBox',
    'STICKY_COMPARE_HEIGHT': 'compareRateHeaderHeight',
    // 'SEARCH_FILTER_TYPE': 'setSearchFilterType'
  },
  template: {
    's2-propertyRecords': propertyRecordsTemplate,
    'propertyRecords-V2': multiRatePropertyRecordsTemplate,
    'propertyRecords-destination': propertyRecordsDestinationTemplate,
    'propertyRecords-hotelQuickView' : propertyRecordsHotelQuickviewTemplate,
    'propertyRecords-hotelQuickView-V2' : propertyRecordsMultiRateHotelQuickviewTemplate,
    'propertyRecords-groupSearch' : propertyRecordsGroupSearchTemplate,
    'propertyRecords-groupSearchHQV': propertyRecordsGroupSearchHQVTemplate,
    'propertyRecords-carousel':propertyRecordsCarouselTemplate
  },
  compareRateList : {},
  mapData: {
    properties: [],
    duplicateProperties: [],
    imageUrl: {},
    isAddressPin: false,
    isHotelPin:false
  },
  formData: {
    submitData: {}
  },
  options: {
    'propertyRecordPosition': 60,
    'MAP_VIEW_ELEMENT': '.js-map-container',
    'MAP_VIEW_LIST_ELEMENT': '#merch-property-results',
    'MAP_PROPERTY_RECORD': '.property-record-item',
    'MAP_VIEW_SCROLL_ELEMENT': '.map-view-scroll-space',
    'LIST_VIEW_ELEMENT': '',
    'LIST_VIEW_LIST_ELEMENT': '',
    'autoCloseBubble': true,
    'TYPE_A': 'A'
  },
  events: {
    'click .load-previous-item, .load-next-item': 'loadPreviousNextRecord',
    'click .js-hotel-near-me': 'setGeoLatLong',
    'click .map-base-view .property-record-tile-item': 'propertyRecordScroll',
    'click .property-record-item': 'focusMapToPropertyPin',
    'click .multi-rates-property-record': 'focusMapToPropertyPin',
    'click .js-view-rate-btn-link': 'doRateBlockNavigation',
    'click .mi-popover,.mi-popover-category': 'openPopup',
    'mouseenter .desktop-map-base-view .property-record-tile-item': 'focusInMapMarkerPin',
    'mouseleave .desktop-map-base-view .property-record-tile-item': 'focusOutMapMarkerPin',
    'click .tile-category-title': 'openPopup',
    'click .m-dropdown': 'dropDownMouseHandler',
    'click .gm-style-iw .cta-close': 'closeInfoWindow',
		'click .js-toggle-list-pane' : 'toggleListPanel',
    'click .js-hotel-rating' : 'openRatingTab',
    'click .js-reviews' : 'openRatingTab',
    'click .js-add-to-rfp-btn': 'groupSearchAddToRFP',
    'click .js-added-to-rfp-btn' : 'groupSearchRemoveRFP',
    'click .js-groups-book-now-btn' : 'groupSearchBookNow',
    'click .js-load-rate-btn' : 'loadPropertyRates',
    'mouseenter .stacked-info-window': 'closeStackedInfoWindow',
    'click .js-save-hotel': 'toggleSaveHotel',
    'click .toggle-hotel-available, .toggle-full-price': 'toggleAvailableFilter',
    'click .js-show-more-rates': 'showRateList',
    'click .l-hide-container': 'hideRateList',
    'click .next': 'nextColumn',
    'click .previous': 'prevColumn',
    'click .l-add-rate-block': 'openSearchSummaryForm',
    'keydown li[data-propertytab]': 'compareRatePropertyTabHandler',
    'keydown li[data-ratetab]': 'compareRateRateTabHandler',
    'click .no-link': 'noLinkClick',
    'keyup .js-toggle-rate-list .l-rate-container, .js-toggle-rate-list .l-hide-container': 'moveToNextElement',
    'click .m-map-page-nation.l-hide-properties-section': 'hideMapPropertyRecordsList',
    'click .js-view-rates-calendar': 'openRatesCalendar',
    'click .js-hide-rates-calendar': 'closeAdfRatesCalendar',
		'click #map-container': 'hidePropertyCard',
		'click #map': 'hidePropertyCard',
    'mouseenter .js-property-record-item': 'infoWindowOnMouseEnter',
    'click .view-hotel-details':'openInfoWindowModal',
    'click .brand-text-open':'openBrandDrawerSection',
    'click .brand-text-close':'closeBrandDrawerSection',
    'keydown .brand-text-open':'openBrandDrawerSection',
    'keydown .brand-text-close':'closeBrandDrawerSection',
    'click .mandatory-fee-pop-up-box': 'openMandatoryFeeModal',
    'keydown .mandatory-fee-pop-up-box':'openMandatoryFeeModal',
  },
  bindEvents: function() {
    var _self = this;

    _self.mapClickPinColorflag = true;
    _self.filterType = _self.options.TYPE_A;
    if (_self.$el.data().type) {
      _self.filterType = _self.$el.data().type;
		}
				
		if (_self.filterType !== _self.options.TYPE_A) {
			_self.checkWindowScroll();
		}

    //	Variation based logic for backdrop.

    if ($('.tile-search-filter').hasClass('filters-v2') && 
							!$('.tile-search-filter').hasClass('type-E')) {
      _self.isPropertyRecordsDisabled = true;
    } else {
      _self.isPropertyRecordsDisabled = false;
    }
    _self.isNewListMapViewEnabled = $('.l-container-width').length;
    
    _self.sessionId = _self.getSessionToken();
    _self.$viewContainer = _self.$el.find('div[data-view], p[data-view], fieldset[data-view]');
    _self.registerPopups();
    var viewType = _self.$viewContainer.data('view');
    if(!viewType)
      return;

    _self.isMapView = viewType === this.CONSTANT.viewTypeMap;
    _self.isCompareView = viewType === this.CONSTANT.viewTypeCompare;
    _self.isNoClusterView = _self.$el.data('map-no-cluster-view')
    _self.$viewContainer.addClass('l-init');

    this.initResponsiveUtils();
    this.setContextWrapperBox();
    this.setOptions();
    this.initMapData();
    this.makePaginationSticky(this.$el.data('isrfpshortlisted'));
    this.newSearchPath();

    // NOTE: infoWindowContentEl is used by Google Maps to show the Buble above a map pin
    this.infoWindowContentEl =  $('<div class="map-property-bubble"></div>')[0];
    this.infoWindowContentEl.addEventListener('click', this.infoWindowContentClickHandler.bind(this));

    this.googleApiWrapper = null;
    this.showPopup();
    this.showPopupTaxAndFee();
    this.windowWidth = $(window).width();
    this.lastMarker;

    // if(this.$el.find('.property-record-map-view').length) {
      // _self.initGoogleApi();
    // }
		// if(this.$el.find('.property-record-map-view').length) {
      // _self.hideFooterInMap();
    // }
    if (window.location.protocol === 'https:' &&  _self.$el.data('china')) {
      if (!_self.isMapView) {
        _self.$el.find('#list-toggle').click();
      }
      _self.setListMapView = $.noop;
    } else {
      //if(this.$el.find('.property-record-map-view').length) {
        this.initMapView();
      //}
    }

    _self.setView(viewType);
    _self.toggleGroupSearchClasses();
    _self.addEllipsis();
    if(_self.context.context.localeKey != 'en_US'){
      _self.changeGroupSearchRateBlock();
    }
    if(_self.$el.find('.compare-table').length){
      // _self.compareHotelTitleEllipsis();
      _self.compareRateFixedHeader();
      _self.compareRateList.sideBar = this.$el.find('.hotel-name-container').width();
      _self.initCompareObj();
      _self.checkWindowSize();
    }

    if(_self.isNewListMapViewEnabled){
      _self.hideCompareTab();
    }

    // Add recently viewed ribbons to the properties
    if(_self.$el.data("showRecentlyViewedProperties")) {
      _self.addRecentlyViewedRibbons();
    }
    _self.setSearchResultPositionDataLayer();
    _self.newUISearchCookie();
    this.newSearchPath();
     _self.setSearchResultViewDataLayer();
     var searchView = $('.tile-property-records-toolbar .js-toggle-view') || 
     $('.tile-property-records-toolbar .l-multi-rate-button');
     if(searchView != undefined){
      searchView.on("click", function() {
        setTimeout(function(){
        _self.setSearchResultViewDataLayer();
         },100);
    });
   }
  },
  // setSearchFilterType: function _setSearchFilterType(type) {
  //   if (!type || type !== 'A') {
  //     _self.isPropertyRecordsEnabled = false;
  //   } else {
  //     _self.isPropertyRecordsEnabled = true;
  //   }
  // },
  /**
  * This function is used to initiate responsive utils
  */
  initResponsiveUtils: function() {
    this.responsiveUtils = ResponsiveUtils.create();
    this.responsiveUtils.init();
  },
  /**
   *  This function is used add recently viewed ribbons 
   */
  addRecentlyViewedRibbons: function _addRecentlyViewedRibbons() {
    var _self = this,
    recentlyViewedData = JSON.parse(window.localStorage.getItem("miRecentlyViewedProperties"));

    var currentTime = new Date().toISOString();

    if (!recentlyViewedData || !recentlyViewedData.recentlyViewedProperties) {
      return;
    }

    var marshaCodes = recentlyViewedData.recentlyViewedProperties.filter( function (property) {
      var timeDiff = Math.abs(new Date(currentTime).getTime() - new Date(property.createdAt).getTime()),
      daysDifference = Math.ceil(timeDiff / (1000 * 3600 * 24));
      return daysDifference <= recentlyViewedData.config.maxCachedDaysLimit;
    }).map(function (property) {
      return property.marshaCode.toLowerCase();
    });

    if(!marshaCodes.length) {
      return;
    }

    _self.$el.find('.js-property-results').find(".property-record-item, .property-item").each(function () {
      var marshaCode,
      $propertyElement = $(this);
      marshaCode = $propertyElement.hasClass("property-item") ? $propertyElement.find(".l-hotel-name a.js-hotel-quickview-link").data("marsha") : $propertyElement.data("marsha");
      if (marshaCode) {
        marshaCode = marshaCode.toLowerCase();
        if (marshaCodes.indexOf(marshaCode) !== -1) {
          _self.addRibbonForProperty($propertyElement);
        }
      }
    });
  },
  /**
   * This function adds recently viewed ribbon to the property image
   */
  addRibbonForProperty: function _addRibbonForProperty(el) {
    var $imageContainer = el.find(".js-image-container"),
      recentlyViewedlabel = this.$el.data("recentlyViewedLabel");
    if (!$imageContainer.find(".m-merch-shape-1").length) {
      $imageContainer.prepend("<span class='l-new-hotel m-merch-shape-1 m-merch-style-1 recently-viewed-ribbon'>" + recentlyViewedlabel + "</span>");
    } else {
      $imageContainer.find(".m-merch-shape-1").addClass("recently-viewed-ribbon").html(recentlyViewedlabel);
    }
  },
  /**
   * This method is used to set latitude and longitude on click of button.
   * @param {Object} event Is the event object passed.
   * @return {Boolean} True or false whether the function sucessfully executed or not.
   */
  setGeoLatLong: function(e) {
			this.geoLocationHandler = new GeoLocationHandler({
				$el: this.$el,
				$parent: this.$parent,
				autoComplete: this
			});
			this.geoLocationHandler.setLatLong(e);
		},

	/**
	 * Update the filter value in the query params
	 */
	toggleAvailableFilter: function(event) {
    var inputElem = this.$el.find(".toggle-hotel-available"),
      fullPriceLabel = this.$el.find('.toggle-full-price').data('full-price'),
		  queryParams = {};
		if( window.location.search ) {
			window.location.search.substr(1).split('&').forEach(function findParam(param) {
				var params = param.split('=');
				queryParams[params[0]] = params[1];
			});
    }
    if($(event.target).hasClass('toggle-hotel-available')) {
      queryParams[inputElem.data('filter')] = event.target.checked;
    } else {
      queryParams[fullPriceLabel] = event.target.checked;
    }
		queryParams['page'] ? queryParams['page'] = 1 : '';
		
		window.location = this.$el.data('refine-search-url') + $.param(queryParams);
	},
  /**
   * This method is used to toggle save hotel icon status
   * @param {Object} event Is the event object passed.
   * @return {Boolean} True or false whether the function sucessfully executed or not.
   */
  toggleSaveHotel: function(event) {
    var _self = this;
    event.stopPropagation();
    var propertyCode = $(event.currentTarget).data('marshaCode'),
      $target = _self.$el.find('.js-save-hotel[data-marsha-code='+ propertyCode +']'),
      saveHotel = $target.data('save-hotel');

    _self.makeAjaxCall({
      url: $target.data('savePropertyUrl'),
      method: "GET",
      data: {
        save: !saveHotel,
        marshaCode: $target.data('marshaCode')
      },
      success: function(data) {
        if(data.status == "success") {
          $target.find('.toggle-heart').toggleClass("t-icon-save t-icon-heart");
          $target.data("save-hotel", !saveHotel);
          $target.find('.js-saved-label').toggle();
          $target.find('.js-save-label').toggle();
          $target.toggleClass('l-show-saved-label');
          saveHotel ? $target.attr('aria-label', _self.$el.data('hotelUnsavedLabel')) : $target.attr('aria-label', _self.$el.data('hotelSavedLabel'));
        }
      }
    });
  },

  /**
   * This method is used to stop opening of the rating tab on the map view.
   * @param {Object} event Is the event object passed.
   * @return {Boolean} True or false whether the function sucessfully executed or not.
   */
  openRatingTab: function(event) {
    if(this.isMapView && !$(event.target).hasClass('js-reviews')) {
      event.preventDefault();
    }
  },

  /**
   * Framework callback to help unbind the event handlers
   */
  unBindEvents: function($) {
    $('[data-component-id="' + this.$el.data('component-id') + '"] *').off();
  },

  /**
   * This function is used to initiate the loading of google api
   * @method initGoogleApi
   * @param {function} callback Is the optional callback passed to this method to execute when google api is
   *                            initiated successfully.
   * @return {[void]}
   */
  initGoogleApi: function(callback) {
    var _self = this;
    var api = _self.$el.find('#map-container').data('options').api;
    var language = _self.$el.data('language-code');

    GoogleApi
    .create({
      apiUrl: api,
      language: language,
      success: function() {
        // [TBD: remove it] Fix R2.2 Merge issue  _self.googleApiWrapper = apiWrapper;
        _self.renderApi();
        return !typeof callback == 'function' ? true : callback();
      },
      error: function() {
        _self.$el.closest('.map-view-wrapper').find('.merch-property-map-results,.scroll-wrapper,.property-record-pagination').remove();
        _self.$el.parent().find('#error-messages').removeClass('is-hidden');
      }
    })
    .init();
  },
  
  /** Baidu map start
   * This funtion is used to set the event listener on the label.
   * @param {Object} label
   */
  ctsCreateMarkerBaidu: function () {
    var _self = this;
    _self.markerCluster = new baiduCluster.BMapLib.MarkerClusterer(_self.bmap, {
      markers: _self.markersBaidu,
      styles: [
        {
          url: this.mapData.imageUrl.clustImg,
          textColor: 'white',
          size: new BMap.Size(70, 70)
        }
      ]
    })
  },
  createBaiduMarker: function(mapData, markerData, indexBaidu){
    var _self = this;    
    var propCount = 0;
    var iconBaidu = new BMap.Symbol(BMap_Symbol_SHAPE_CIRCLE, {
          scale: 0.1,
          strokeWeight: 0.1,
          strokeOpacity: 0,
          fillColor: '#494949',
          fillOpacity: 0
        });
      var label= _self.createLabel(markerData, indexBaidu);
      var marker= new BMap.Marker(new BMap.Point(markerData.longitude,markerData.lat),{
          icon: iconBaidu
      });
      marker.customData=markerData;
      marker.customData.indexBaidu=indexBaidu;
      label.customData=marker.customData;
      label.customData.marker=marker;
      marker.setLabel(label);
      this.addEventToLabel(label);
      _self.markersBaidu.push(marker);      
  },

  /**
   * This funtion is used to set the event listener on the label.
   * @param {Object} label
   */
  addEventToLabel: function (label) {
    var _self = this;
    label.addEventListener('mouseover', function (e) {
      window.loadAllPictures(document.querySelectorAll('picture', this.infoWindowEl));
      e.target.infoWindow.open(label.getPosition());
      $(this.ba).addClass("hover");
      $(e.target.infoWindowEl).find('.l-property-name').dotdotdot({
        height: 45
      });
    });
    label.addEventListener('mouseout', function (e) {
      e.target.infoWindow.close();
      $(this.ba).removeClass("hover");
    });
    if (label.index.length) {
      label.addEventListener('click', function (e) {
        e.target.infoWindow.close();
      });
      label.addEventListener('mouseover', function (e) {
        e.target.infoWindow.open(label.getPosition());
        var that = this;
        $(this.ba).addClass("hover");
        var dupMarker = $(this.ba).children();          
          dupMarker.on("click", function(){
            that.infoWindow.close();
            var markers = _self.markerCluster.getMarkers();
            if(!_self.$el.hasClass('show-destination-view')) {
            _self.onPropertyPinSelected(markers[$(this).data("propindex")],$(this).data("propindex"));
            }
          });
      }); 
    }else{
      label.addEventListener('click', function (e) {
        e.target.infoWindow.close();
        if(!_self.$el.hasClass('show-destination-view')) {
          _self.onPropertyPinSelected(this.customData.marker, this.customData.indexBaidu);
          $(this.ba).addClass("hover");
        }
      });
    }
  },

  /**
   * Create label.
   * @param {Object} markerData the data of the markers.
   * @return {Object} label
   */
  createLabel: function(markerData, index) {
    var _self = this;
    var label = {};
    if (markerData.isDuplicate) {
      var marker = this.createDuplicateBaiduMarker(markerData);
      var content = marker.markerHtml;
      label = new BMap.Label(content, {
        offset: new BMap.Size(0, 0)
      });
      label.index = marker.index;
      this.addEventToLabel(label);
    } else {
      var content = this.createBaiduMarkerWithLabel(markerData);
      label = new BMap.Label(content, {
        offset: new BMap.Size(0, 0)
      });
      label.index = index;
      this.addEventToLabel(label);
    }
    label.infoWindowEl = this.createInfoWindowEl(label, markerData.isDuplicate);
    label.infoWindow = new baiduInfoWindow.BMapLib.InfoBox(
      _self.bmap,
      label.infoWindowEl, {
        closeIcon: false,
        offset: new BMap.Size(10, 2)
      }
    ); // create infowindow object
    label.markerData = markerData;
    label.setStyle({
      color: '#fff',
      background: 'none',
      border: '0 solid #fff',
      borderRadius: '.3125rem',
      fontSize: '.75rem',
      padding: '0'
    });
    return label;
  },

  /**
  * This function is used to create a custom marker and to bind its event.
  * @param {Object} markerData 
  * @return {String} Baidu map marker Label
  **/
  createBaiduMarkerWithLabel: function(markerData) {
    var _self = this, marker, propertyBedIcon, markerLabel, propertyTypeLabelClass,
      propertyTypeLabel = markerData.propertyType || '';
    propMarkerLabel = markerData.propMarkerLabel;
    propertyBedMarkerLabel = markerData.propMarkerBedLabel;
  
    propertyTypeLabelClass = Object.keys(_self.mapData.propertyTypes).find(function (key) {
      return _self.mapData.propertyTypes[key] === propertyTypeLabel ? true : false;
    }) || 'default';
  
    if (_self.mapData.isHotelPin) {
      markerLabel = markerData.hotelName.slice(0, MapConfig.markerProps.hotelLength);
    } else {
      markerLabel = markerData.points || (markerData.symbol && getSymbolFromCurrency(markerData.symbol) || "") + (markerData.price || "");
    }
  
    if (this.mapData.propertyBedMarkerLabel['openingSoonUpperCaseLabel'] == propertyBedMarkerLabel) {
      propertyTypeLabelClass += ' ' + 'openingSoonUpperCaseLabel';
    } else if (this.mapData.propertyBedMarkerLabel['callToBookUpperCaseLabel'] == propertyBedMarkerLabel) {
      propertyTypeLabelClass += ' ' + 'callToBookUpperCaseLabel';
    } else if (this.mapData.propertyMarker['unavailableUpperCaseLabel'] == propMarkerLabel) {
      markerLabel = propMarkerLabel;
      propertyTypeLabelClass += ' ' + 'unavailableUpperCaseLabel';
    } else if (!markerLabel) {
      propertyTypeLabelClass += ' blank';
      markerLabel = '';
    }
    return '<div class="map-marker map-marker-' + propertyTypeLabelClass + '"><span class="room-type m-merch-shape-3 m-merch-style-1">' + propertyTypeLabel + '</span><div class="map-rate-details">' + markerLabel + '<span class="t-icon-bedding"></span></div><div class="arrow"></div></div>';
  },

  createBaiduPoint: function(lat, long) {
    return new BMap.Point(long, lat);
  },

  /**
    * This function is used to create a custom marker and to bind its event.
    * @return {Object} google map marker Object
    **/
  createDuplicateBaiduMarker: function() {
    var _self = this, marker,
      propertyTypeLabel,
      propMarkerLabel,
      propertyBedMarkerLabel,
      propertyTypeLabelClass,
      markerHtml = '',
      dupPropData = _self.mapData.duplicateArrayList[0].split(",");
      dupPropDataLength = dupPropData.length,
      propertyTypeLabelArr = [], indexArr = [],
      data = _self.mapData.properties;
  
    $.each(dupPropData, function (i, value) {
      propertyTypeLabelArr.push(data[value.split("|")[1]].propertyType);
    });
  
    if (propertyTypeLabelArr.indexOf(_self.mapData.propertyTypes["newUpperCaseLabel"]) > 0) {
      var splicedArr = dupPropData.splice(propertyTypeLabelArr.indexOf(_self.mapData.propertyTypes["newUpperCaseLabel"]), 1);
      dupPropData.unshift(splicedArr[0]);
    }
  
    if (propertyTypeLabelArr.indexOf(_self.mapData.propertyTypes["newUpperCaseLabel"]) == -1 && propertyTypeLabelArr.indexOf(_self.mapData.propertyTypes["lowUpperCaseLabel"]) > 0) {
      var splicedArr = dupPropData.splice(propertyTypeLabelArr.indexOf(_self.mapData.propertyTypes["lowUpperCaseLabel"]), 1);
      dupPropData.unshift(splicedArr[0]);
    }
  
    var index, markerLabel;
    for (var i = 0; i < dupPropDataLength; i++) {
  
      index = dupPropData[i].split("|")[1] * 1;
  
      if (data[index].marshaCode.toUpperCase() === dupPropData[i].split("|")[0].toUpperCase()) {
        indexArr.push(index);
        if (_self.mapData.isHotelPin) {
          markerLabel = data[index].hotelName.slice(0, _self.mapData.hotelLength);
        } else {
          markerLabel = data[index].points || (data[index].symbol && getSymbolFromCurrency(data[index].symbol) || "") + (data[index].price || "");
        }
        propertyTypeLabel = data[index].propertyType || '';
        propMarkerLabel = data[index].propMarkerLabel;
        propertyBedMarkerLabel = data[index].propMarkerBedLabel;
  
        propertyTypeLabelClass = Object.keys(_self.mapData.propertyTypes).find(function (key) {
          return _self.mapData.propertyTypes[key] === propertyTypeLabel ? true : false;
        }) || 'default';
  
        if (_self.mapData.propertyBedMarkerLabel['openingSoonUpperCaseLabel'] == propertyBedMarkerLabel) {
          propertyTypeLabelClass += ' ' + 'openingSoonUpperCaseLabel';
        } else if (_self.mapData.propertyBedMarkerLabel['callToBookUpperCaseLabel'] == propertyBedMarkerLabel) {
          propertyTypeLabelClass += ' ' + 'callToBookUpperCaseLabel';
        } else if (_self.mapData.propertyMarker['unavailableUpperCaseLabel'] == propMarkerLabel) {
          markerLabel = propMarkerLabel;
          propertyTypeLabelClass += ' ' + 'unavailableUpperCaseLabel';
        } else if (!markerLabel) {
          propertyTypeLabelClass += ' blank';
          markerLabel = '';
        }
  
        markerHtml += '<div class="duplicate-map-marker map-marker map-marker-' + propertyTypeLabelClass + '" data-propIndex = ' + index + '>' + (i == 0 ? '<span class="room-type m-merch-shape-3 m-merch-style-1">' + propertyTypeLabel + '</span>' : '') + '<div class="map-rate-details">' + markerLabel + '<span class="t-icon-bedding"></span></div>' + (i == dupPropDataLength - 1 ? '<div class="arrow"></div>' : '') + '</div>'
      }
    }
  
    var marker = {
      markerHtml: markerHtml,
      index: indexArr
    }
    return marker;
  },

  /**
  * This function is used to display property record info on over of map marker.
  * @param {Object} marker on which event is triggered.
  * @param {Object} isDuplicate flag for markers.
  * @return void
  **/
  createInfoWindowEl: function(marker, isDuplicate) {
    var _self = this;
    var infoWindowEl = $('<div class="map-property-bubble"></div>')[0];
    if (isDuplicate) {
      var infoString, $propertyRecord, parentElem = $('<div>', { class: "stacked-info-window" });
      var $parentElem = $(parentElem)
      for (var i = 0; i < marker.index.length; i++) {
        $propertyRecord = _self.findMapForRecord(marker.index[i]);
        infoString = _self.getBaiduCloneElement($propertyRecord, marker);
        $parentElem.append(infoString);
      }
      infoWindowEl.innerHTML = parentElem[0].outerHTML;
    } else {
      var $propertyRecord = _self.findMapForRecord(marker.index);
      var infoString = _self.getBaiduCloneElement($propertyRecord);
      infoWindowEl.innerHTML = infoString[0].outerHTML;
    }
    return infoWindowEl;
  },
  
  getBaiduCloneElement: function($propertyRecord, marker) {
    var _self = this;
    var infoString = $propertyRecord.clone().addClass('l-hovered-property');
    if (!$propertyRecord.length) {
      infoString = $('<div>', { html: _self.$el.data('searchlocation') }).addClass("searchedPin");
    }
    var $infoString = $(infoString);
    // Remove the source tags as it would place an incorrect image
    $infoString.removeClass('.in-focus');
    $infoString.find('.js-hotel-details').removeClass('l-padding-left-five-quarters');
    $infoString.find('source').remove();
    $infoString.find('.macro-card-property-type').removeClass('l-display-none');
    $infoString.find('.t-icon-container').hide();
    return $infoString;
  },
  /**
  * Baidu Map end
  **/
  initBaidu: function () {
    var _self = this;
    _self.bmap = new BMap.Map("baidumap", {enableAutoResize:true, enabelMapClick:false});
    _self.markersBaidu = [];
    _self.bmap.enableScrollWheelZoom();
    _self.bmap.mapData = _self.mapData;
    if(_self.mapData.cityCenter.longitude && _self.mapData.cityCenter.latitude){
      _self.bmap.centerAndZoom(new BMap.Point(_self.mapData.cityCenter.longitude, _self.mapData.cityCenter.latitude), 10);
    } else {
      _self.bmap.centerAndZoom(new BMap.Point(_self.mapData.properties[0].longitude, _self.mapData.properties[0].lat), 10);      
    };
    _self.bmap.addControl(new BMap.NavigationControl({anchor: BMAP_ANCHOR_TOP_LEFT}));
    _self.bmap.addControl(new BMap.OverviewMapControl());
    _self.bmap.addControl(new BMap.MapTypeControl());
    options = { offset: new BMap.Size(150, 5) };
    _self.bmap.addControl(new BMap.ScaleControl(options));
    for (var i = 0; i < _self.mapData.properties.length; i++) {
      _self.createBaiduMarker(_self.mapData, _self.mapData.properties[i], i);
    }    
    _self.ctsCreateMarkerBaidu();
    var cityCenterMarker = new BMap.Marker(new BMap.Point(_self.mapData.cityCenter.longitude, _self.mapData.cityCenter.latitude),{ icon: new BMap.Icon("https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png", new BMap.Size(27,43))});
    _self.bmap.addEventListener("resize", function () {
    _self.bmap.setZoom(15);
    _self.addEllipsis();
    if(_self.mapData.cityCenter.longitude && _self.mapData.cityCenter.latitude){
      _self.bmap.panTo(new BMap.Point(_self.mapData.cityCenter.longitude, _self.mapData.cityCenter.latitude));
      _self.bmap.addOverlay(cityCenterMarker);
    } else {
      _self.bmap.panTo(new BMap.Point(_self.mapData.properties[0].longitude, _self.mapData.properties[0].lat));
    };
    });
  },
	hideFooterInMap : function(viewType){
    var _self = this;
    if(!_self.options.isDestinationPage) {
      if(viewType === this.CONSTANT.viewTypeMap){
        $('.m-footer').hide();
        this.$el.addClass('bottom-padding-none');
  		}else{
        $('.m-footer').show();
        this.$el.removeClass('bottom-padding-none');
  		}
    }
	},
  /**
  * This function is used to add ellipsis to long property names
  **/
  addEllipsis: function() {
    var _self= this;
    if (this.responsiveUtils.isTablet()) {
      _self.$el.find('.multi-rates-property-record .l-property-name, .l-hotel-address').dotdotdot({
        height: 48
      })
    }

  },
  /**
  * This function is used to open pop over on click of photo viewer/hotel category link.
  **/
  openPopup: function(e) {
    e.preventDefault();
    var popupInstance = {};
    if ($(e.currentTarget).hasClass('mi-popover')) {
      popupInstance = this.viewPhotosInstance;
    }else if ($(e.currentTarget).hasClass('tile-category-title')) {
      popupInstance = this.categoryTitlePopupInstance;
    } else {
      popupInstance = this.categoryPopupInstance;
    }
    if(popupInstance.popupOptions.items){
      popupInstance.popupOptions.items.src = $(e.currentTarget).attr('href') ? $(e.currentTarget).attr('href') : $(e.currentTarget).data('url');
    }

    popupInstance.openPopup();
    return true;
  },

  /**
  * This function is used to render google map.
  * @return void
  **/
  renderApi: function() {
    var _self = this;

    // passing data to map handler
    _self.mapHandler = MapHandler.create({
      isNoClusterView: _self.isNoClusterView,
      $el: _self.$el.find('#map'),
      markerData: _self.mapData
    }); 

    _self.mapHandler.renderApi();
    window.googleMaps.addListener('idle', function() {
      _.defer(function() {
        if (_self.selectedPropertyRecordForHQV) {
          _self.highlightPin(_self.mapHandler.markers[_self.selectedPropertyRecordForHQV.find('.property-record-tile-item').data('pnum')], Constants.PROPERTY_RECORD.MARKER_PIN_BLUE);
        }
        if (_self.mapPlacesFilters && !_self.mapPlacesFilters.preventMarkerPinUpdate) {
          _self.mapPlacesFilters.mapZoomChangeEventHandler();
        }
      });
    });
    // map click handler
    window.googleMaps.addListener('click', function() {
      // destination page scenario
      if (_self.options.isDestinationPage) {
        _self.mapHandler.infoWindow.close();
        _self.mapHandler.isInfoWindowPersist = false;
        _self.deHighlightPins();
      }
    });

    // inititalize map filters
    this.enableMapBasedSearch = this.$el.data('enable-map-based-search');
    if(this.enableMapBasedSearch) {
      this.initMapPlacesFilters();
    }

    if( this.options.isDestinationPage ) {
    }
  },

  /**
  * This function is used to handle events of map marker.
  * @param {Object} event type of Event triggered on map marker.
  * @param {Object} marker on which event is triggered.
  * @param {Object} infoWindow google map info object.
  * @return void
  **/
  mapMarkerEventsHandler: function(event, marker, infoWindow, markerArrayIndex) {
    // hide map places filters pins on marriott property pin hover
    if (this.mapPlacesFilters) {
      this.mapPlacesFilters.closeAllInfoWindow();
    }
    var mapMarkerInfo = this.$el.find(".map-property-bubble");
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    switch (event) {
      case Constants.GLOBAL.MOUSE_CLICK_EVENT:
        if($('.js-property-list-container').data('ismapclickpin') && (window.innerWidth >= 1023) && !isMobile){
          if(mapMarkerInfo.length > 0){
            this.hidePropertyRecordInfoOnMarker(marker, infoWindow);
          }
          if (this.lastMarker && this.mapClickPinColorflag) {
            this.hidePropertyRecordInfoOnMarker(this.lastMarker, this.mapHandler.infoWindow);
          }
          if ( this.mapClickPinColorflag ) {
            this.mapClickPinColorflag = false;
          }
          this.showPropertyRecordInfoOnMarker(marker, infoWindow);
        } else {
          if (this.options.isDestinationPage) {
            if (!this.responsiveUtils.isMobileOrTablet()) {
              this.deHighlightPins();
              infoWindow.close();
              this.showPropertyRecordInfoOnMarker(marker, infoWindow);
            }
          } else {
            this.onPropertyPinSelected(marker, markerArrayIndex);
          }
        }
        break;
      case Constants.GLOBAL.MOUSE_OVER_EVENT:
        if(!$('.js-property-list-container').data('ismapclickpin')){
          this.showPropertyRecordInfoOnMarker(marker, infoWindow);
        }
        break;
      case Constants.GLOBAL.MOUSE_OUT_EVENT:
        if(!$('.js-property-list-container').data('ismapclickpin')){
          this.hidePropertyRecordInfoOnMarker(marker, infoWindow);
        }
          break;
      default : 
        break;
    }
  },

  /**
  * This function is used to display property record info on over of map marker.
  * @param {Object} marker on which event is triggered.
  * @param {Object} infoWindow google map info object.
  * @return void
  **/
 showPropertyRecordInfoOnMarker: function(marker, infoWindow) {
  var _self = this;
  
  _self.lastMarker = marker;

  if(marker.markerIndex && marker.markerIndex.length) {
    var infoString, $propertyRecord, parentElem = $('<div>', { class: "stacked-info-window"});
    var $parentElem = $(parentElem)
    for(var i=0; i < marker.markerIndex.length; i++) {
      $propertyRecord = _self.findMapForRecord(marker.markerIndex[i]);
      infoString = _self.getCloneElement($propertyRecord, marker);
      $parentElem.append(infoString);
    }
    if(_self.infoWindowContentEl){
      _self.infoWindowContentEl.innerHTML = parentElem[0].outerHTML;
    }
  } else {
    var $propertyRecord = _self.findMapForRecord(marker.markerIndex);
    var infoString = _self.getCloneElement($propertyRecord, marker);
    if(_self.infoWindowContentEl){
      _self.infoWindowContentEl.innerHTML = infoString[0].outerHTML;   
    } 
  }

  var $infoString = $(infoString);  
  if(_self.mapData && _self.mapData.isHotelPin) {
    $infoString.find('.js-hotel-name').removeClass('t-dotdotdot');
  }
  
  if ((this.responsiveUtils && !this.responsiveUtils.isDevice()) || this.options.isDestinationPage) {
    _self.highlightPin(marker, Constants.PROPERTY_RECORD.MARKER_PIN_BLUE);

    
    infoWindow.setContent(_self.infoWindowContentEl);
    if(!infoWindow.getMap()) {
      infoWindow.open(window.googleMaps, marker);
    }

    //NOTE: enable infowindow close timer for default property record tile

    if (this.options && this.options.autoCloseBubble) {
      _self.$el.find('.gmnoprint').on('mousemove', function() {
      if (_self.infoWindowIdleTimer) {
        clearTimeout(_self.infoWindowIdleTimer);
      }
      _self.infoWindowIdleTimer = setTimeout(function() {
        infoWindow.close();
      }, Constants.PROPERTY_RECORD.MAP_INFO_WINDOW_IDLE_TIME);
      });
    }
  }
  
},

  getCloneElement: function($propertyRecord, marker) {
    var _self = this;
    var infoString = $propertyRecord.clone().addClass('l-hovered-property');
    if( !$propertyRecord.length ) {
      infoString = $('<div>', { html: _self.$el.data('searchlocation') }).addClass("searchedPin");
    }
    if(_self.mapHandler){
      _self.mapHandler.currentMarker = marker;
    }

    var $infoString = $(infoString);
    var resizedSrc = $infoString.find('.js-image-container').data('imageurl') + '?resize=375:150';
    // Remove the source tags as it would place an incorrect image
    $infoString.removeClass('.in-focus');
    $infoString.find('.js-hotel-details').removeClass('l-padding-left-five-quarters');
    $infoString.find('source').remove();
    $infoString.find('.macro-card-property-type').removeClass('l-display-none');
    $infoString.find('.t-icon-container, .t-icon-external-site').hide();
    $infoString.find('.l-hotel-picture img').attr('src', resizedSrc);
    if($infoString.data('associateview')) {
      $infoString.find('.js-hotel-location .js-hotel-rating').removeClass('t-border-right');
    }
    var rateBlock = $infoString.find(".primary-rate-row .l-rates-wrapper").clone();
    $infoString.find(".l-hotel-detail-container").append(rateBlock);
    $infoString.find(".l-rate-selection-btn").hide();

    // if($infoString.find(".l-rates-unavailable-message").length == 2){
    //   $infoString.find(".l-rates-unavailable-message").eq(0).hide();
    // } else
    if($infoString.find(".l-rates-unavailable-message").length == 1) {
      if($infoString.find(".rate-block").length || $infoString.find(".points-block").length) {
        $infoString.find(".l-rates-unavailable-message").eq(0).hide();
        if($infoString.find(".points-block").length == 0) {
          $infoString.find(".l-rates-wrapper").addClass('rate-primary');
        }
      }
    }
    else if($infoString.find('.l-hotel-detail-container .l-rate-unavailable-container').length == 1) {
      if($infoString.find('.l-hotel-detail-container .rate-block').length || $infoString.find('.l-hotel-detail-container').find(".points-block").length) {
        $infoString.find('.l-hotel-detail-container .l-rate-unavailable-container').eq(0).hide();
        if($infoString.find('.l-hotel-detail-container .points-block').length == 0) {
          $infoString.find('.l-hotel-detail-container .l-rates-wrapper').addClass('rate-primary');
        }
      } else {
        $infoString.find('.l-hotel-detail-container .l-rate-unavailable-container').eq(0).find('.l-special-rate-label').hide();
        $infoString.find('.l-hotel-detail-container .l-rate-unavailable-container').addClass("highlight-unavailable")
      }
    }
    if($infoString.find('.l-hotel-detail-container .rate-block').length == 1 && $infoString.find('.l-hotel-detail-container .points-block').length == 1) {
      $infoString.find('.l-hotel-detail-container .l-rates-wrapper').eq(1).find('.l-special-rate-label').hide();
    }
    if($infoString.find('.l-hotel-detail-container .rate-block').length == 0 && $infoString.find('.l-hotel-detail-container .points-block').length == 0) {
      $infoString.find('.l-hotel-detail-container .l-rate-unavailable-container').addClass('selected-rates-available');
    }
    if($infoString.find('.l-hotel-detail-container .rate-block').length == 0 && $infoString.find('.l-hotel-detail-container').find(".points-block").length == 1) {
      $infoString.find('.l-hotel-detail-container .js-view-rates-link').addClass('points-primary');
    }
    // If rates are cash only
    if($infoString.find('.l-hotel-detail-container .rate-block').length == 1 && $infoString.find('.l-hotel-detail-container').find(".points-block").length == 0) {
      $infoString.find('.l-hotel-detail-container .l-rates-wrapper').addClass('rate-only');
    }
    window.loadAllPictures(document.querySelectorAll('picture', $infoString[0]));

    return $infoString;
  },

  
  /**
  * This function is used to display property record info on over of map marker.
  * @param {Object} marker on which event is triggered.
  * @param {Object} infoWindow google map info object.
  * @return void
  **/
  hidePropertyRecordInfoOnMarker: function(marker, infoWindow) {
    var infoWindowContainer = this.$el.find('.gm-style-iw').parent().parent();
    this.highlightPin(marker, Constants.PROPERTY_RECORD.MARKER_PIN_BLACK);

    this.$el.find('.gmnoprint').off('mousemove');
    if (this.infoWindowIdleTimer) {
      clearTimeout(this.infoWindowIdleTimer);
    }

    infoWindowContainer.removeClass('custom-info-window');
    infoWindowContainer.removeClass('address-info-window');
    infoWindow.close();
  },

  /**
  * This function is used to highlight the marker pin/cluster icon.
  * @param {Object} marker on which event is triggered.
  * @param {Constant} color marker pin color.
  * @return void
  **/
  highlightPin: function(marker, color) {
    var _self = this;
    var markersInCluster;
    if(marker.isAddressPin){
      return false;
    }
    if(!_self.isNoClusterView){
      var clusters = this.mapHandler.markerCluster.clusters_;
      _self.resetCluster();
      if (color === Constants.PROPERTY_RECORD.MARKER_PIN_BLUE) {
        markersInCluster = _.filter(clusters, function(clust) {
          return (_.indexOf(clust.markers_, marker) != -1);
        });

        if (markersInCluster.length && markersInCluster[0].markers_.length > 1)  {
          markersInCluster[0].clusterIcon_.div_.style.backgroundImage = 'url(\'' + _self.mapData.imageUrl.clustBlue + '\')';
        }
      }
    }
    _self.setMarkerIcon(marker, color);
  },

  /**
   * Dehighlight all pins
   */
  deHighlightPins: function() {
    var _self = this;
    if(!window.baidumap){
      _self.mapHandler.markers.forEach(function(marker) {
        _self.setMarkerIcon(marker, Constants.PROPERTY_RECORD.MARKER_PIN_BLACK);
      });
    }
  },

  /**
  * This function is used to reset the marker cluster icon.
  * @return void
  **/
  resetCluster: function() {
    var clusters = this.mapHandler.markerCluster.clusters_;
    var _self = this;
    var markerHQVSelected;

    _.forEach(clusters, function(cluster) {
      if (_self.selectedPropertyRecordForHQV) {
        markerHQVSelected = _.filter(clusters.markers_, function(marker) {
          return marker.isHQVOpened;
        });
      }
      if (!markerHQVSelected) {
        cluster.clusterIcon_.div_.style.backgroundImage = 'url(\'' + _self.mapData.imageUrl.clustImg + '\')';
      }
    });
  },

  /**
  * This function is used to set the marker pin icon.
  * @param {Object} marker on which event is triggered.
  * @param {Constant} color marker pin color.
  * @return void
  **/
  setMarkerIcon: function(marker, color) {

    if(MapConfig.customControl) {
      return this.setMarkerIconWithLabel(marker, color);
    } 

    if (color === Constants.PROPERTY_RECORD.MARKER_PIN_BLACK) {
      MapConfig.markerProps.icon.url = this.mapData.imageUrl.pinImg;
      MapConfig.markerProps.hotelIcon.url = this.mapData.imageUrl.pinImg;
    } else {
      MapConfig.markerProps.icon.url = this.mapData.imageUrl.pinBlue;
      MapConfig.markerProps.hotelIcon.url = this.mapData.imageUrl.pinBlue;
    }
    if(this.mapData.isHotelPin) {
      marker.setIcon(MapConfig.markerProps.hotelIcon);
    } else {
      marker.setIcon(MapConfig.markerProps.icon);
    }
    marker.setZIndex(100);
  },

/**
  * This function is used to set the custom marker pin icon.
  * @param {Object} marker on which event is triggered.
  * @param {Constant} color marker pin color.
  * @return void
  **/
 setMarkerIconWithLabel: function(marker, color) {

  if (color === Constants.PROPERTY_RECORD.MARKER_PIN_BLACK) {
    marker.set('labelClass', 'markerLabels');
  }
  else {
    marker.set('labelClass', 'markerLabels hover');
  }
  
  marker.setZIndex(1000);
},

  /**
  * This function is used to higlight the marker pin icon on hover of property record.
  * @param {Object} e Event property record on which event is triggered
  * @return void
  **/
  focusInMapMarkerPin: function(e) {
    if (!this.responsiveUtils.isMobileOrTablet() && this.mapHandler && !this.selectedPropertyRecordForHQV) {
      this.highlightPin(this.mapHandler.markers[$(e.currentTarget).data('pnum')], Constants.PROPERTY_RECORD.MARKER_PIN_BLUE);
    }
  },

  /**
  * This function is used to higlight the marker pin icon on hover of property record.
  * @param {Object} e Event property record on which event is triggered
  * @return void
  **/
  focusOutMapMarkerPin: function(e) {
    if (this.mapHandler && !$(e.currentTarget).find('.hotel-quick-view-map').hasClass('ishidden')) {
      this.highlightPin(this.mapHandler.markers[$(e.currentTarget).data('pnum')], Constants.PROPERTY_RECORD.MARKER_PIN_BLACK);
    }
  },
  /**
  * This function is used to initiate responsive utils
  */
  initResponsiveUtils: function() {
    this.responsiveUtils = ResponsiveUtils.create({
      orientationChangeEventHandler: _.bind(this.orientationChangeEventHandler, this),
      resizeEventHandler: _.bind(this.resizeEventHandler, this)
    });
    this.responsiveUtils.init();
  },

  /**
  * This function is used to handle resize event.
  */
  resizeEventHandler: function() {
    var $window = $(window);
    var _self = this;
    _self.addEllipsis();
    // To prevent unexpected resize event fire on iphone/ipad
    if (_self.windowWidth != $window.width()) {
      _self.windowWidth = $window.width()

      // Scroll Up if in mobile view
      if( this.responsiveUtils.isMobile() && !_self.isMapView )
        this.pubsub.publish('STICKY_SCROLL_TO_TOP');
      this.setContextWrapperBox();

      // toggle map markers visibility for destination page scenario
      if (this.options.isDestinationPage && !_self.$el.find('.js-property-records-baidu').length) {
        if (this.responsiveUtils.isDesktop() ||
              (this.responsiveUtils.isTablet() && !this.responsiveUtils.isPortrait())) {
          this.mapHandler.setMarkersVisible(true);
          this.mapHandler.addMarkersCluster();
        } else {
          this.mapHandler.setMarkersVisible(false);
          this.mapHandler.clearMarkersCluster();
        }
      }
    }

    //
  },
  /**
  * This function is used to handle orientation change event.
  */
  orientationChangeEventHandler: function() {
    var _self = this;
    // To prevent unexpected resize event fire on iphone/ipad
    if (_self.windowWidth != $(window).width()) {
      _self.windowWidth = $(window).width()
      var propertyMapResults = _self.$el.find('#merch-property-map-results');
      if(!_self.responsiveUtils.isMobile()) {
        if (_self.responsiveUtils.isPortrait()) {
          _self.initQuickViewScroller(propertyMapResults, false);
          _self.addTakeover();
        } else {
          _self.removeTakeover();
        }
      }
      if( _self.filterTakeover && _self.responsiveUtils.isMobile()  && _self.responsiveUtils.isPortrait() && _self.filterTakeover.$el.hasClass("js-filter-takeover")) {
        _self.filterTakeover.hide();
      }
    }
  },

  /**
  * This function is used to set/calculate the neassory values for the presentation.
  *  * Calc the offset for map-view scroll
  *  * Calc the height the tile should consume in Map View
  *  * Calc the Widht of a card in the given view port
  */
  setContextWrapperBox: function(stickyContainerHeight) {
    var _self = this;
    var $mapView = _self.$el.find(this.options.MAP_VIEW_ELEMENT);
    var $window = $(window);
    var $mapViewScrollPanel = _self.$el.find(this.options.MAP_VIEW_SCROLL_ELEMENT);
    var $propertyRecords = $mapViewScrollPanel.find('.property-record-item, .multi-rates-property-record');
    var $navButtons = $mapViewScrollPanel.find('.m-button-page-nation');
    var propertysCount = $propertyRecords.length;
    var navButtonsCount = $navButtons.length;
    var redemptionMessageHeight = _self.$el.find('.redemption-rate-msg').outerHeight(true);
    if(!_self.isMapView && !_self.isCompareView){
      $mapViewScrollPanel.removeAttr('style');
      return;
    }

    _.defer(function() {
      if( !_self.options.isDestinationPage ){
        var height = $window.height() - _self.$el.offset().top + (stickyContainerHeight ? stickyContainerHeight : 0),
        windowHeight = $window.height();
  
        if(_self.$el.hasClass('l-promo-property-records')){
          $mapView.height(windowHeight - _self.CONSTANT.mapViewOffset);
          _self.$el.find(_self.CONSTANT.mapView).height(windowHeight - _self.CONSTANT.mapViewOffset);
        } else {      
          $mapView.height(height + (redemptionMessageHeight ? redemptionMessageHeight : 0)); // the top padding
          _self.$el.find(_self.CONSTANT.mapView).height(height);
        }

      }
      $mapViewScrollPanel.css('left', '');
      _self.options.scrollMargin = parseInt($mapViewScrollPanel.css('left'));
      // Card Horizontal Length
      _self.options.cardHorLen = DomUtilities.boxWidth($propertyRecords.first());

      if( _self.responsiveUtils.isMobileOrTablet() )
        $mapViewScrollPanel.css('width',
          (_self.options.cardHorLen * propertysCount) + (DomUtilities.boxWidth($navButtons.first()) * navButtonsCount));
      else
        $mapViewScrollPanel.css('width', '');

      _self.resizeMapHandler();
      if (_self.$el.find('.in-focus').data('pnum') != 0) {
        _self.propertyRecordScroll({currentTarget: _self.$el.find('.in-focus')});
      }
    });
  },

  /**
   * Help Init the Map View for all View Ports
   */
  initMapView: function() {
    var propertyRecords = this.$el.find(this.options.MAP_VIEW_LIST_ELEMENT);
    this.bindTouchEvents(propertyRecords[0]);
  },

  /**
  * This function is used to initialize custom loading animation
  */
  initLoader: function(parentElem) {
    var loader = new Loader({
      parentElem: parentElem,
      className: 'loading-icon',
      label: this.$el.data('spinner-label')
    })
    loader.start();
  },

  /**
  * This function is used to handle the click event on load previous/next record.
  * @param {Object} e Click event triggered on load previous/next property record.
  */
  loadPreviousNextRecord: function(e) {
    var propertyRecordClicked = this.$el.find(e.currentTarget);
    if (propertyRecordClicked.hasClass('in-focus')) {
      window.location = propertyRecordClicked.attr('href');
    } else {
      this.propertyRecordScroll(e);
    }
  },

  /**
  * This function is used to handle the click event on property record.
  * @param {Object} e Click event triggered on property record.
  */
  propertyRecordScroll: function(e) {
    if(e && !e.currentTarget)
      return;
    var $propertyRecords = this.$el.find(this.options.MAP_VIEW_LIST_ELEMENT);
    var $scrollElement = this.$el.find(this.options.MAP_VIEW_SCROLL_ELEMENT);
    var scrollPosition = null;
    var previousSelectedIndex = 0;
    var currentSelectedIndex = 0;

    if( !$propertyRecords.hasClass('is-animating') ) {
      var $gotTo = $(e.currentTarget);
      var $currentSelected = $propertyRecords.find('.in-focus');
      previousSelectedIndex = parseInt($currentSelected.data('pnum'));
      currentSelectedIndex = parseInt($gotTo.data('pnum'));
      scrollPosition = parseInt($scrollElement.css('left')) - ($gotTo.offset().left - this.options.scrollMargin);
      $currentSelected.removeClass('in-focus');
      // if( $gotTo.hasClass('map-view-property-record') )
      $gotTo.addClass('in-focus');
    }

    if(this.$el.find(".js-property-records-baidu").length>0) {
      this.focusMapToPropertyPin(e);
    } else {
      var dupMarkerList = this.mapHandler.duplicateMarkers,
      dupCurrentIndex,
      dupPreviousIndex;

      if (dupMarkerList) {
        for(var i = 0; i < dupMarkerList.length; i++) {
          var arr = dupMarkerList[i].markerIndex;
          if(arr.indexOf(currentSelectedIndex) != -1) {
            dupCurrentIndex = i;
          }
          if(arr.indexOf(previousSelectedIndex) != -1) {
            dupPreviousIndex = i;
          }
        }
      }

      if (this.mapHandler) {
        if (this.mapHandler.markers[previousSelectedIndex]) {
          this.highlightPin(this.mapHandler.markers[previousSelectedIndex], Constants.PROPERTY_RECORD.MARKER_PIN_BLACK);
        }
        if (this.mapHandler.markers[currentSelectedIndex] && !this.isPropertyRecordsHidden()) {
          this.highlightPin(this.mapHandler.markers[currentSelectedIndex], Constants.PROPERTY_RECORD.MARKER_PIN_BLUE);
        }
      }
      if(dupMarkerList) {
        if (dupMarkerList[dupPreviousIndex]) {
          this.highlightPin(dupMarkerList[dupPreviousIndex], Constants.PROPERTY_RECORD.MARKER_PIN_BLACK);
        }
        if (dupMarkerList[dupCurrentIndex] && !this.isPropertyRecordsHidden()) {
          this.highlightPin(dupMarkerList[dupCurrentIndex], Constants.PROPERTY_RECORD.MARKER_PIN_BLUE);
        }
      }
    }

    this.isMapPlacesOpened = false;
    this.propertyRecordAnimate($scrollElement, scrollPosition);
  },

  /**
  * This function is used to animate the property record.
  * @param {Object} element HTML element which needs to be animated.
  * @param {Number} position the position to which property record needs to be animated.
  */
  propertyRecordAnimate: function(element, position) {
    var _self = this,
      propertyRecords = this.$el.find(this.options.MAP_VIEW_LIST_ELEMENT),
      currentSelectedIndex = propertyRecords.find('.in-focus').data('pnum'),
      animatePosition;

    element.addClass('is-animating');
    if(_self.context.context.isRTL){
      animatePosition = {right: '' + (-position)};
    }
    else{
      animatePosition = {left: '' + position};
    }
    element.stop(true, true).animate(animatePosition, Constants.PROPERTY_RECORD.NAVIGATION_SPEED, function() {
      var mapCenter = {};
      element.removeClass('is-animating');
      var currentMarker = _self.mapData.properties[currentSelectedIndex];

      if ( !_.isEmpty(_self.mapData.properties) && window.googleMaps && currentMarker ) {
        mapCenter.lat = currentMarker.lat;
        mapCenter.lng = currentMarker.longitude;
        window.googleMaps.panTo(new google.maps.LatLng(mapCenter.lat,mapCenter.lng));
      }
    });
  },

  /**
  * This function is used to handle the touch/swipe events on property record.
  * @param {Object} element HTML element on which the touch event needs to be binded.
  */
  bindTouchEvents: function(element) {
    if(!element)
      return;
    element.addEventListener('touchstart', _.bind(this.touchStartHandler, this), false);
    element.addEventListener('touchend', _.bind(this.touchEndHandler, this), false);
    $(element).addClass('touch-event-binded');
  },
  /**
  * This function is used to handle the swipe events on property record.
  * @param {Bool} isRightSwipe to determine the direction of swipe.
  */
  handleswipe: function _handleswipe(isRightSwipe) {
    var _self = this,
      propertyRecords = this.$el.find(this.options.MAP_VIEW_LIST_ELEMENT),
      selectedRecord = propertyRecords.find('.in-focus'),
      nextElement; // Simulated Event Object to be passed to propertyRecordScroll

    if(isRightSwipe && _self.context.context.isRTL || (!isRightSwipe && !_self.context.context.isRTL)){
      nextElement = selectedRecord.next();
    }
    else{
        nextElement = selectedRecord.prev();
    }

    //if( nextElement.hasClass('map-view-property-record') || nextElement.hasClass('m-button-page-nation') )
      this.propertyRecordScroll({currentTarget: nextElement});
  },

  /**
  * This function is used to handle the touch move event on property record.
  * @param {Object} e Click event triggered on property record.
  */
  touchMoveHandler: function _touchMoveHandler(e) {
    if (this.isMapView && this.responsiveUtils.isMobileOrTablet() && this.$el.find('.hotel-quick-view-map').find('.hotel-information-block.page-take-over').length == 0) {
      e.preventDefault();
    }
  },

  /**
  * This function is used to handle the start of touch events on property record.
  * @param {Object} e Click event triggered on property record.
  */
  touchStartHandler: function _touchStartHandler(e) {
    var touchobj = e.changedTouches[0];
    this.dist = 0;
    this.startX = touchobj.pageX;
  },

  /**
  * This function is used to handle the end of touch events on property record.
  * @param {Object} e Click event triggered on property record.
  */
  touchEndHandler: function _touchEndHandler(e) {
    var touchobj = e.changedTouches[0];
    this.dist = touchobj.pageX - this.startX; // get total dist traveled by finger while in contact with surface
    if (Math.abs(this.dist) >= Constants.PROPERTY_RECORD.SWIPE_THRESHOLD_DISTANCE) {
      this.handleswipe(this.dist > 0);
    }
  },

  /**
  * This function is used to manage rate block navigation for map based list view mobile/tablet view.
  * @param {Object} event Click event triggered on rate block click.
  */
  doRateBlockNavigation: function(event) {
    if (this.isMapView && this.responsiveUtils.isMobileOrTablet() && !$('.js-property-list-container').data('ismapclickrate')) {
      event.preventDefault();
    }
  },

  /**
   * Open RLM Page on click of propery card in Destination Page
   * @param {Object} event Click event triggered on rate block click.
   */
  openRLMDestinationPage: function(event) {
    if( this.options.isDestinationPage ) {
      var $target = $(event.currentTarget);
      if(event.target.className.indexOf("l-property-name") === -1 && event.target.className.indexOf("l-save-hotel") === -1) {	
        event.preventDefault();
        window.location = $target.find('.js-view-rate-btn-link').attr('href');
      }
    }
  },

  /**
  * This function is used to handle map view on browser resize.
  */
  resizeMapHandler: function() {
    if (!window.BMap && window.google && google.maps) {
      google.maps.event.trigger(window.googleMaps, 'resize');
      if(this.mapHandler) {
        this.mapHandler.setMapView();
      }
    }
  },

  /**
   * Initializes map filters
   */
  initMapPlacesFilters: function() {
    var $mapPlacesFilters = $('#mapPlacesFilters');
    if ($mapPlacesFilters[0]) {
      this.mapPlacesFilters = new MapPlacesFilters($mapPlacesFilters, this.mapHandler, _.bind(this.mapPlacesClickHandler, this));
    }
  },

  /**
   * Init the Data Model used by Map's by reading the dom elements
   */
  initMapData: function() {
    var _self = this;
    if(_self.mapHasInitiated){
      return;
    }
    _self.mapHasInitiated = true;
    var $propertyRecords = {},
      blankProps = 0,
      dupArray = [],
      duplicatePropArray = _self.$el.data('duplicateProperty');
      $propertyRecords = _self.$el.find('.js-property-record-item')

    if(duplicatePropArray) {
      dupArray = duplicatePropArray.join().split(",").map(function(ele){
        return ele.split("|")[1]*1;
      });
    }
    
    // creating data for map markers
    $propertyRecords.each(function(i, elm) {
      var propData = $(elm).data('property');
      if(propData.blank) {
        blankProps++;
      }
      if(dupArray.indexOf(i) != -1) {
        propData.isDuplicate = true;
      }
      _self.mapData.properties.push(propData);
    });

    if(_self.mapData.properties.length === blankProps) {
      $.each(_self.mapData.properties, function(i,propertyData) {
        delete propertyData.blank;
      });
    }

    _self.mapData.persistInfoWindowOnClick = _self.options.persistInfoWindowOnClick || false;
    _self.mapData.isInfoWindowRateListMenuLink = _self.options.persistInfoWindowOnClick || false;
    _self.mapData.cursor = this.options.isDestinationPage ? 'pointer' : 'default';
    // set map options for destination page
    if (this.options.isDestinationPage) {
      _self.mapData.hideMarker = false;//!_self.responsiveUtils.isDesktop();
      _self.mapData.isMapDraggable = !!_self.options.isMapDraggable;
      _self.mapData.isMapNoClear = !!_self.options.isMapNoClear;
    }

    _self.mapData.imageUrl = _self.$el.data('img');
    _self.mapData.isAddressPin = _self.$el.data('isaddress');
    _self.mapData.searchLat = _self.$el.data('searchlat');
    _self.mapData.searchLong = _self.$el.data('searchlong');
    _self.mapData.isHotelPin = _self.$el.data('isgroupsearch');
    _self.mapData.showCityCenter =  _self.$el.data('show-city-center');
    _self.mapData.cityCenter =  _self.$el.data('city-center');
    _self.mapData.propertyTypes = _self.$el.data('propertyTypes') || "";
    _self.mapData.propertyMarker = _self.$el.data('propertyMarker') || "";
    _self.mapData.propertyBedMarkerLabel = _self.$el.data('propertyBedMarkerLabel') || "";
    _self.mapData.duplicateArrayList = duplicatePropArray;
    if (_self.$el.hasClass('l-promo-property-records')) {
      _self.mapData.gestureHandling = 'cooperative';
    }
    else{
      _self.mapData.isScrollwheel = this.options.isDestinationPage ? false : true;
    }
  },

  /**
   * Set options for property records component
   */
  setOptions: function() {
    var options = this.$el.data('options') || {};
    this.options = _.assign(this.options, options);
  },

  /**
   * Handling map places click for highlighting/dehiglighting the property markers pins
   */
  mapPlacesClickHandler: function(isMapPlacesOpened) {
    var _self = this;
    this.isMapPlacesOpened = isMapPlacesOpened;
    if (isMapPlacesOpened) {
      _self.deHighlightPins();
    }
  },

  /**
   * InfoWindow event handler
   */
  infoWindowContentClickHandler: function(evt) {
    // redirect to rate list menu page
    if (this.mapData.isInfoWindowRateListMenuLink) {
      if( this.options.isDestinationPage ) {
        if(evt.target.className.indexOf("l-property-name") === -1 && evt.target.className.indexOf("l-save-hotel") === -1) {	
          this.rateListMenuLinkRedirect(evt.currentTarget.children[0].getAttribute('data-marsha')); 
        }
      }
      else {
        this.rateListMenuLinkRedirect(evt.currentTarget.children[0].getAttribute('data-marsha')); 
      }     
    }
  },

  /**
   * Perform url redirection with element data-attributes
   * @param {Object} rateListMenuLink - HTML Element
   */
  rateListMenuLinkRedirect: function(marshaCode) {
    var data = this.$el.data('ratelistMenuLink');
    var url = '';

    if (data && marshaCode) {
      url = data.propertyCardURL + marshaCode;
      url += '&' + data.fromDateKey + '=' + data.fromDateVal;
      url +=  '&' + data.toDateKey + '=' + data.toDateVal;

      window.location.href = url;
    }
  },

  /**
   * This function is used to open Hotel fact Sheet Popup
   * @param {Object} event Mouse event triggered on filter icon click.
   */
  showPopup: function () {
    var $searchAllHotelInfoLink = this.$el.find('.js-search-all-hotel-info-link');
    var showHotelFactSheetPopup;
    
    // don't proceed if link doesn't exist
    if ($searchAllHotelInfoLink.length === 0) {
      return;
    }

    showHotelFactSheetPopup = new Popup({
      selector: '.js-search-all-hotel-info-link',
      sourceBlock: '.modal-content',
      alternateCloseMarkup: true
    });
    showHotelFactSheetPopup.register();
  },

  showPopupTaxAndFee: function () {
    var $taxesAndFeeLink = this.$el.find('.js-tax-and-fee');
    var taxesAndFeesPopup;

    // don't proceed if link doesn't exist
    if ($taxesAndFeeLink.length === 0) {
        return;
    }

    taxesAndFeesPopup = new Popup({
      selector: '.js-tax-and-fee',
      sourceBlock: '.modal-content',
      alternateCloseMarkup: true
    });
    taxesAndFeesPopup.register();
  },

   /**
    * This is used to switch the tile view from List or Map Views
    * respectively based on the argument
    *
    * @param viewType {String} the type of view to be shown to the user
    */
    CONSTANT: {
      mapView: 'div[data-view="map"]',
      viewTypeMap: 'map',
      viewTypeList:'list',
      viewTypeCompare:'compare',
      add: 'Add',
      remove: 'Remove',
      listView: 'div[data-view="list"]',
      mapViewCSS: 'l-l-col-3 l-margin-none l-padding-none l-l-col-propertys-list',
      listViewCSS: 'l-s-container-fullbleed',
      mapViewOffset : 190
    },
   setView: function _setView(viewType) {
     this.$viewContainer.attr('data-view', viewType).removeAttr('style');
     this.$el.find('.mi-scrollbar').remove();
    var $container = this.$el.find('.js-list-container'),
        $listPicture = this.$el.find('.list-picture'),
        $mapPicture = this.$el.find('.map-picture'),
        $multiRatePropertyList = this.$el.find('.js-property-list-container'),
        $compareRate = this.$el.find('.compare-table');

        this.pubsub.publish('SRP_VIEW_CHANGED', [viewType]);

        if(viewType === this.CONSTANT.viewTypeMap || viewType === this.CONSTANT.viewTypeList){
          if(!$multiRatePropertyList.length){
            this.compRefresh(viewType);
            return;
          }
        } else if(viewType === this.CONSTANT.viewTypeCompare) {
          if(!$compareRate.length) {
            this.compRefresh(viewType);
            return;
          }
        }

    this.hideFooterInMap(viewType);

    this.pubsub.publish("HIDE_STICKY_SEARCH_FORM", [this.CONSTANT.viewTypeMap === viewType, _.bind(this.resizeMapView, this), false]);
		if(viewType === this.CONSTANT.viewTypeMap) {
      this.isMapView = true;
      this.isCompareView = false;
      $listPicture.hide();
      $mapPicture.show();
      $compareRate.hide();
      $multiRatePropertyList.show();
						// Closing if any ADF calendar opened
      this.closeAdfRatesCalendar();
      $container.addClass(this.CONSTANT.mapViewCSS).removeClass(this.CONSTANT.listViewCSS);
      if (this.$el.find(".js-property-records-baidu").length) {
        this.initBaidu();
      } else {
        this.initGoogleApi(this.resizeMapView); // Initiating google api when switching to map view.
      }
		} else if(viewType === this.CONSTANT.viewTypeList) {
      this.isMapView = false;
      this.isCompareView = false;      
      $mapPicture.hide();
      $listPicture.show();
      $compareRate.hide();
      $multiRatePropertyList.show()
      $container.removeClass(this.CONSTANT.mapViewCSS).addClass(this.CONSTANT.listViewCSS);
		} else if(viewType === this.CONSTANT.viewTypeCompare){
      this.isMapView = false;
      this.isCompareView = true;      
      $mapPicture.hide();
      $multiRatePropertyList.hide();
      $listPicture.show();
      $compareRate.show();
      $container.removeClass(this.CONSTANT.mapViewCSS).addClass(this.CONSTANT.listViewCSS);
      this.initCompareObj();
      this.updateViewOnWindoResize(this.compareRateList.compareWindowWidth, this.compareRateList.compareContainerWidth);
    }
    this.setContextWrapperBox();
    this.addEllipsis();
    this.pubsub.publish('TOGGLE_STICKY_PANEL', [viewType === this.CONSTANT.viewTypeMap]);
    this.pubsub.publish('PROPERTY_RECORDS_VIEW_CHANGE', [viewType]);
    this.toggleGroupSearchClasses(viewType);
    window.loadAllPictures && window.loadAllPictures(document.querySelectorAll('picture'));
    // Adding class to body if mapview is selected in mobile / tablet view
    if(this.isMapView && this.responsiveUtils.isMobileOrTablet() && !this.isGroupSearchActive()) {
      $('body').addClass('map-view-active');
    } else {
      $('body').removeClass('map-view-active');
    }
   },

   compRefresh: function(viewType) {
    var _self = this,
      $container = this.$el.find('.js-list-container');
      $loader = new LoadingIndicator($container);

    $loader.addLoader();
    var context = {
      "viewType": viewType
    }
    _self.refresh(context, function(){
      $loader.removeLoader();
      window.loadAllPictures(document.querySelectorAll('picture'));
    });
   },

   /**
   * resize map view callback
    */
    resizeMapView: function() {
      var _self = this;
      _self.setContextWrapperBox();
      _self.resizeMapHandler();
    },

   /**
    * Find a property record dom element used by the Map View
    */
   findMapForRecord: function(index) {
     return this.$el.find(this.CONSTANT.mapView + ' div[data-pnum="' + index + '"]');
   },

   /**
    * Set the maps focues to the given lat lng location
    *
    * @param {google.map.LatLng} latLng
    */
   setFocuesOnMap: function(latLng) {
    if (!window.BMap && window.googleMaps) {
      if( !(latLng instanceof google.maps.LatLng) ) {
        latLng = new google.maps.LatLng(latLng.lat || latLng.latitude, latLng.lng || latLng.longitude);
      }

      var latLngBounds = new google.maps.LatLngBounds(latLng);

      // window.googleMaps.fitBounds(latLngBounds);
      window.googleMaps.setCenter(latLng);
      window.googleMaps.panToBounds(latLngBounds); // panTo, setCenter
    }
    if (window.baidumap) {
      this.bmap.centerAndZoom(latLng, 18);
    }
   },

  focusMapToPropertyPin: function(evt) {
    var $propertyRecord = $(evt.currentTarget);
    if( this.mapHandler && $propertyRecord.length ) {
      var propertyMarker = this.mapHandler.markers[$propertyRecord.data('pnum')];
      this.setFocuesOnMap(propertyMarker.getPosition());
      this.openRLMDestinationPage(evt);
    }
    if(window.baidumap && this.markerCluster){
      var propertyMarker = (this.markerCluster.getMarkers())[$propertyRecord.data('pnum')];
      this.setFocuesOnMap(propertyMarker.getPosition());
    }
  },

  /**
  * This function is used to display property on click of map pin.
  * @param {Object} marker on which event is triggered.
  * @param {Object} markerArrayIndex for case of duplicate pins
  * @return void
  **/
  onPropertyPinSelected: function(marker,markerArrayIndex) {
    var _self= this;
    var $propertyRecordsList = this.$el.find(this.options.MAP_VIEW_LIST_ELEMENT);
    var $propertyRecords = this.$el.find('.js-list-container[data-view="map"]');
    if(!$propertyRecordsList.length)
      return;
    var markerIndex = typeof(markerArrayIndex)=='number'? markerArrayIndex : marker.markerIndex;
    var $propertyRecord = this.findMapForRecord(markerIndex);
    if(!this.responsiveUtils.isMobileOrTablet() || this.isGroupSearchActive()) {
      this.openHotelQuickViewPopup($propertyRecord);
    }
    if( $propertyRecord.length ) {
      if(!this.responsiveUtils.isMobileOrTablet() || this.isGroupSearchActive()) {
        $propertyRecordsList.scrollTop( $propertyRecordsList.scrollTop() + $propertyRecord.offset().top );
        $propertyRecordsList.find('.in-focus').removeClass('in-focus');
        $propertyRecord.addClass('in-focus');
      } else {
        _self.propertyRecordScroll({currentTarget: $propertyRecord});
      }
      this.setFocuesOnMap(marker.getPosition());
    }
    if(_self.$el.find('.js-property-records-baidu').length === 0){
      this.highlightPin(marker, !this.isGroupSearchActive() ? Constants.PROPERTY_RECORD.MARKER_PIN_BLUE : Constants.PROPERTY_RECORD.MARKER_PIN_BLACK);
      this.mapHandler.infoWindow.close();
    }
    // Remove the class to hide propertyRecords
    $propertyRecords.removeClass('hide-map-property-list');

    this.toggleTabSelection(false);
  },

  /**
	 * Dropdown menu mouse event handler
	 */
	dropDownMouseHandler: function(evt) {
		if( !$(evt.target).hasClass('m-dropdown-option') )
			this.openDropDown(evt.currentTarget);
  },

  /**
   * Close Info window on hover of Stacked Info Properties
   */
  closeStackedInfoWindow: function() {
    if (!$('.js-property-list-container').data('ismapclickpin')) {
      this.mapHandler.infoWindow.close();
      this.highlightPin(this.lastMarker, Constants.PROPERTY_RECORD.MARKER_PIN_BLACK);
    }
  },

	/**
	 * Open the menu
	 */
	openDropDown: function(menu) {
		var $menu = $(menu);
		var $list = $menu.find('.m-dropdown-list');

		if( $menu.hasClass('in-focus') ) {
			$menu.removeClass('in-focus');
		} else {
			$menu.addClass('in-focus');
			$list.find('.m-dropdown-option').first().focus();
		}
  },

  /**
   * CTA to Close the Map Info Window on click of the X in the Info Window
   */
  closeInfoWindow: function() {
    this.mapPlacesFilters.closeAllInfoWindow();
  },

  /**
   * Subscriber Handler for SEARCH_FILTER_VISIBLE
   */
  hidePropertyRecords: function() {
    if(this.isPropertyRecordsDisabled) {
      this.$el.addClass('search-results-inactive');
    } else {
      this.$el.hide();
    }
  },

  /**
   * Subscriber Handler for SEARCH_FILTER_HIDDEN
   */
  showPropertyRecords: function() {
    if(this.isPropertyRecordsDisabled) {
      this.$el.removeClass('search-results-inactive');
    } else {
      this.$el.show();
    }
  },

  toggleListPanel : function _toggleListPanel (e) {
    var _self = this, ele = $(e.target);
    if(ele.hasClass('js-is-active-list-pane')){
      ele.removeClass('js-is-active-list-pane t-icon-arrow-left').addClass('t-icon-arrow-right');
      _self.$el.find('.js-map-view-property-list').removeClass('m-map-view-property-list-active').addClass('m-map-view-property-list-hidden');
    }else{
      ele.addClass('js-is-active-list-pane m-map-view-property-list-active t-icon-arrow-left').removeClass('t-icon-arrow-right');
      _self.$el.find('.js-map-view-property-list').addClass('m-map-view-property-list-active').removeClass('m-map-view-property-list-hidden');
    }
  },

  /**
   * @description This function matches marshaCode of hotel in list view, find href and registers popup to open when propertypin is selected
   * @param {object} Property which is clicked
   * @returns {boolean} returns true if popup is registerd successfully
   */
  openHotelQuickViewPopup : function _openHotelQuickViewPopup($propertyRecord) {
    var propertyObj = $propertyRecord.data('property'),
        matchingNode,
        fullUrl,
        isElegant = $propertyRecord.data('isElegant'),
								isHotelQuickSight = this.$el.find('.js-property-list-container').data('isHotelQuickSight');
    matchingNode = this.$el.find('.js-map-quickview-pins').filter(function() {
      return $(this).data('marsha') === propertyObj.marshaCode;
    });
    fullUrl = isElegant ? $propertyRecord.data('viewElegantHotel') : matchingNode.first().attr('href');
    if(propertyObj.brand === 'RZ' || isElegant || isHotelQuickSight) {
      window.open(fullUrl, '_blank');
    }else {
      this.selctedPropertyquickViewPopup =  new Popup({
        open: true,
        url: fullUrl,
        sourceBlock: '.modal-content',
        alternateCloseMarkup: true
      });
      this.selctedPropertyquickViewPopup.register();
    }
    return true;
  },

  groupSearchAddToRFP: function _groupSearchAddToRFP (event) {
    event.preventDefault();
    var $currentCard = $(event.currentTarget),
        $currentPropertyRecord =  $currentCard.closest('.property-record-item'),
        isRitz = $currentPropertyRecord.data('brand') === 'RZ',
        marshaCode = $currentPropertyRecord.data('marsha'),
        imageURL = $currentPropertyRecord.data('imageurl'),
        hotelName = $currentPropertyRecord.data('hotelname'),
        promoCode = $currentPropertyRecord.data('promo-code'),
        promoQuickViewHref = $currentPropertyRecord.data('promohref'),
        isPromoApplicable = $currentPropertyRecord.data('ispromo'),
        promoType = $currentPropertyRecord.data('promotype'),
        promoTitle = $currentPropertyRecord.data('promotitle'),
        propertyToAdd = {
          marshaCode: marshaCode,
          promoId: promoCode,
          imageLink: imageURL,
          hotelName: hotelName,
          isRitzCarlton: isRitz,
          promoApplicable: isPromoApplicable,
          promoQuickViewHref: promoQuickViewHref,
          promoType: promoType,
          promoShortTitle: promoTitle
        };
    var isModal = $('.js-add-to-rfp-btn').parents('.m-modal').length;
    if(isModal) {
      this.pubsub.publish('GROUP_RFP_REQUEST_ADD', [propertyToAdd]);
      setTimeout(function(){  
        location.reload();  
        },2500);
      } else {
      this.pubsub.publish('GROUP_RFP_REQUEST_ADD', [propertyToAdd]);
    }
  },

  groupSearchRemoveRFP: function _groupSearchRemoveToRFP (event) {
    event.preventDefault();
    var $currentCard = $(event.currentTarget),
        $currentPropertyRecord =  $currentCard.closest('.property-record-item'),
        marshaCode = $currentPropertyRecord.data('marsha');

    this.pubsub.publish('GROUP_RFP_REQUEST_REMOVE', [marshaCode]);
    this.removeRfpFromPropertyRecords(marshaCode);
    if($('.js-added-to-rfp-btn').parents('.m-modal').length) {
      setTimeout(function(){  
        location.reload();  
      },2500); 
    }
  },

  addSelectedPropertySuccess : function _addSelectedPropertySuccess (marshaCode) {
    var _self = this;
    _self.$el.find('.t-groups-rfp-btn [data-add-property="'+marshaCode+'"]').addClass('is-hidden');
    _self.$el.find('.t-groups-rfp-btn [data-selected-property="'+marshaCode+'"]').removeClass('is-hidden');
    _self.makePaginationSticky(true);
  },

  makePaginationSticky : function _makePaginationSticky(isRfpTilePresent){
    var $mapViewSection=this.$el.find('.js-property-results, #map-container, #merch-property-results');
    if(isRfpTilePresent) {
      $mapViewSection.addClass('js-pagination-sticky');
    }else{
      $mapViewSection.removeClass('js-pagination-sticky');
    }
  },

  removeRfpFromPropertyRecords: function _removeRfpFromPropertyRecords (marshaCode) {
    var _self = this;
    _self.$el.find('.t-groups-rfp-btn [data-add-property="'+marshaCode+'"]').removeClass('is-hidden');
    _self.$el.find('.t-groups-rfp-btn [data-selected-property="'+marshaCode+'"]').addClass('is-hidden');
  },

  setPropertySpecificData: function _setPropertySpecificData (currentSection) {
    var _self= this,
        $formElement =  _self.$el.find('.js-book-now-hidden-inputs');

    $formElement.find('[name=hwsPropertyName]').val(currentSection.data('hotelname'));
    $formElement.find('[name=hwsMarshaCode]').val(currentSection.data('marsha'));
    $formElement.find('[name=marshaCode]').val(currentSection.data('marsha'));
    $formElement.find('[name="destinationAddress.city"]').val(currentSection.data('city'));
    $formElement.find('[name="destinationAddress.stateCode"]').val(currentSection.data('statecode'));
    $formElement.find('[name="destinationAddress.stateProvince"]').val(currentSection.data('stateprovince'));
    $formElement.find('[name="destinationAddress.country"]').val(currentSection.data('country'));
    $formElement.find('[name="brandCode"]').val(currentSection.data('brand'));

    $formElement.find('[name="functionSpaceID"]').val(currentSection.data('functionSpace'));

    $formElement.find('[name="marshaBrandCode"]').val(currentSection.data('marshaBrandCode'));

    $formElement.find('[name="functionSpaceName"]').val(currentSection.data('functionSpaceName'));
  },

  groupSearchBookNow: function _groupSearchBookNow (event) {
    event.preventDefault();
    var _self = this,
        $currentBlock = $(event.currentTarget).closest('.js-property-record-item');

    _self.setPropertySpecificData($currentBlock);
    _self.$el.find('form').submit();
  },

  toggleGroupSearchClasses: function _toggleGroupSearchClasses(viewType){
    if(viewType && viewType == 'compare'){return;}
      this.$el.find('.opening-soon-text').toggleClass('l-l-col-12 l-l-col-last l-l-col-4');
      this.$el.find('.price-night.l-groups-rate-block').toggleClass('l-l-col-12 l-l-col-last l-l-margin-bottom');
      this.$el.find('.t-groups-book-now-btn').toggleClass('l-l-col-6 l-l-col-2');
      this.$el.find('.t-groups-rfp-btn').toggleClass('l-l-col-6 l-l-col-2');
  },
  changeGroupSearchRateBlock: function _changeGroupSearchRateBlock(){
    var element =  this.$el.find('.t-groups-rfp-btn');
    element.find('a').toggleClass('l-width-max');
  },
  registerPopups: function _registerPopups() {
    if (this.$el.find('.mi-popover').length) {
      this.viewPhotosInstance = new Popup({
        items: {
          type: 'inline'
        },
        selector: '.mi-popover',
        url: this.$el.find('.mi-popover').data('url'),
        mainClass: 'm-photo-gallery-container',
        reverseCloseIcon: true
      });
      this.viewPhotosInstance.register();
    }

    if (this.$el.find('.js-view-hotel-category').length) {
      this.categoryPopupInstance = new Popup({
        selector: '.js-view-hotel-category',
        sourceBlock: '.modal-content'
      });
      this.categoryPopupInstance.register();
    }

    if (this.$el.find('.tile-category-title').length) {
        this.categoryTitlePopupInstance = new Popup({
          selector: '.tile-category-title',
          sourceBlock: '.tile-hotel-category-tier-chart',
          url: this.$el.find('.tile-category-title').attr('href')
        });
        this.categoryTitlePopupInstance.register();
      }

    if(this.$el.find('.modal-popup').length) {
						if (this.$el.find('.js-property-list-container').data('isHotelQuickSight') !== true) {
								this.quickViewPopupInstance = new Popup({
										selector: '.modal-popup',
										sourceBlock: '.modal-content',
										alternateCloseMarkup: true
								});
							this.quickViewPopupInstance.register();
						}
    }

    // if(this.$el.find('.mandatory-fee-pop-up-box').length) {
    //   this.mandatoryFeePopup = new Popup({
    //     selector: '.mandatory-fee-pop-up-box',
    //     alternateCloseMarkup: true,
    //     items: {
    //       type: 'inline',
    //       src: '<div><h3>dailyResortFeeIncludesLabel</h3><p>hello</p></div>'
    //     }
    //   });
    //   this.mandatoryFeePopup.register();
    // }

    if(this.$el.find('.js-photo-gallery').length) {
					if (this.$el.find('.js-property-list-container').data('isHotelGalleryView') !== true) {
						this.photoGalleryPopupInstance = new Popup({
								selector: '.js-photo-gallery',
								sourceBlock: '.modal-content',
								alternateCloseMarkup: true
						});
						this.photoGalleryPopupInstance.register();
						}
    }
    if(this.$el.find('.m-promo-bar').length) {
      this.promoPopupInstance = new Popup({
        selector: '.m-promo-bar',
        sourceBlock: '.modal-content',
        alternateCloseMarkup: true
      });
      this.promoPopupInstance.register();
    }
  },

  loadPropertyRates: function(e) {
    var _self = this
        clickTarget = $(e.target).hasClass('js-load-rate-btn') ? $(e.target) : $(e.target).closest('.js-load-rate-btn');

    var context = {
      "context": {
        "propertyId": clickTarget.data('marsha'),
      },
      "sessionToken": _self.getSessionToken()
    }

    clickTarget.find('.t-spinner').removeClass('is-hidden');
    clickTarget.find('.load-rate-text').addClass('is-hidden');

    _self.makeAjaxCall({
      url: clickTarget.data('loadRateUrl'),
      contentType: 'application/json',
      method: 'POST',
      data: JSON.stringify(context),
      success: function(data){
        var buttonTextWrap = clickTarget.closest('.js-button-text-wrapper');
        clickTarget.find('.t-spinner').addClass('is-hidden');
        clickTarget.find('.load-rate-text').removeClass('is-hidden');
        _self.handleRatesLoad(data, buttonTextWrap, clickTarget);
      },
      error: function(){
        clickTarget.find('.t-spinner').removeClass('is-hidden');
        clickTarget.find('.load-rate-text').addClass('is-hidden');
      }
    });
  },

  handleRatesLoad: function(data, ratesWrap, clickedTarget) {
    var _self = this,
        rateOuterWrap = ratesWrap.find('.js-view-rate-btn-link'),
        rateBlock = rateOuterWrap.find('.rate-block'),
        rateHTML = '',
        pointsFirstNightLabel = rateBlock.data('pointsFirstNightLabel'),
        averagePointsPerNightLabel = rateBlock.data('averagePointsPerNightLabel'),
        perNightLabel = rateBlock.data('perNightLabel'),
        rateHTMLObj = {
          "ratesOnly": '<span class="js-price-night price-night t-font-xs">\
                          <span class="js-price t-price t-font-weight-bold">'+ data.rate.rateValue +'</span>\
                          <span class="js-currency t-font-xs t-line-height-xs">'+ data.rate.rateCurrency + perNightLabel + '</span>\
                        </span>',
          "strikePoints": '<span class="t-font-xs strike-points t-font-weight-semibold">' + data.cashAndPointsRate.points + '</span>\
                           <span class="t-points">' + data.cashAndPointsRate.pointSaversPoints + '</span>',
          "pointsOnly": '<span class="t-points">' + data.cashAndPointsRate.points + '</span>'
        };

    if(data.ratesAvailable) {
      rateHTML += rateHTMLObj.ratesOnly;
      rateBlock.append($(rateHTML));
      if(data.pointsAvailable) {
        rateBlock.addClass('with-points');
        rateBlock.find('.js-price-night').addClass('with-points');
        rateBlock.find('.js-price').html('(' + rateBlock.find('.js-price').html() + ')');
      }
    }
    else {
      if(data.pointsAvailable) {
        rateBlock.addClass('with-points');
        if(data.cashAndPointsRate.cashUpgradeAvailable){
          if(data.cashAndPointsRate.pointSaversAvailable) {
            rateHTML += rateHTMLObj.strikePoints;
          } else {
            rateHTML += rateHTMLObj.pointsOnly;
          }
        } else if(data.cashAndPointsRate.pointSaversAvailable) {
          rateHTML += rateHTMLObj.strikePoints;
        } else {
          rateHTML += rateHTMLObj.pointsOnly;
        }

        rateHTML += '<span class="js-points-label t-font-xs t-line-height-xs></span>';
        if(data.cashAndPointsRate.cashUpgradeAvailable) {
          rateHTML += '<span class="t-font-xs t-line-height-xs">+' + data.cashAndPointsRate.cashRate.rateValue +
                      cashAndPointsRate.cashRate.rateCurrency + perNightLabel + '</span>';
        }
      }

      rateBlock.append($(rateHTML));

      if(data.ratesAvailable || data.cashAndPointsRate.cashUpgradeAvailable) {
        rateBlock.find('.js-points-label').addClass('large-display-as-top-row');
      }

      rateBlock.find('.js-points-label').html(data.migratedFlag ? pointsFirstNightLabel : averagePointsPerNightLabel);
    }
    clickedTarget.addClass('is-hidden');
    rateOuterWrap.removeClass('is-hidden');
  },
  /**
  * This method is used to show multiple rates dropdown.
  * @param {Object} event is the event passed.
  **/ 
  showRateList: function(event) {
    event.preventDefault();
    var _self = this,
      element = $(event.currentTarget),
      showRate = element.parents('.multi-rates-property-record, .js-rate-btn-container'),
      tertiaryRateLabel = showRate.find('.js-rate-selected').first().attr('aria-label');
    if(_self.$el.parents('.mfp-container').length) {
      _self.$el.parents('.mfp-container').removeAttr('aria-live');
    }
    showRate.addClass('multi-rates-expanded');
    showRate.find('.js-toggle-rate-list').slideToggle('slow', function(){
      showRate.find('.js-rate-selected').first().focus().attr('aria-label', _self.$el.data('expandedLabel'));
      setTimeout(function() {
        showRate.find('.js-rate-selected').first().attr('aria-label', tertiaryRateLabel);
        showRate.find('.l-rate-type').attr('aria-hidden', true);
      }, 1500);
    });
  },
  /**
  * This method is used to hide multiple rates dropdown.
  * @param {Object} event is the event passed.
  **/ 
  hideRateList: function(event) {
    event.preventDefault();
    var element = $(event.currentTarget);
    var hideRate = element.parents('.multi-rates-property-record, .js-rate-btn-container');
    hideRate.find('.js-toggle-rate-list').slideToggle('slow', function() {
      hideRate.find('.l-rate-type').removeAttr('aria-hidden');
      hideRate.removeClass('multi-rates-expanded');
    });
    hideRate.find('.more-rates-available-wrapper').focus();
  },
  /**
  * This method handles arrows in multi-rate dropdown.
  * @param {Object} event is the event passed.
  **/ 
  moveToNextElement: function _moveToNextElement(event) {
    var $toFocus;
    if([38, 40].includes(event.which)){
      event.preventDefault();
      if(event.which === 38){
        $toFocus = $(event.currentTarget).prev('.l-rate-container').find('a');
      }else{
        $toFocus = $(event.currentTarget).next('.l-rate-container, .l-hide-container').find('a');
      }
    }
    $toFocus && $toFocus.focus();
  },
  
  noLinkClick: function _noLinkClick(event) {
    event.preventDefault();
  },

  compareRatePropertyTabHandler: function _compareRatePropertyTabHandler(event){
    if(event.which === 9){
      var $element = $(event.currentTarget);
      var $allAnchors = $element.find('.js-tabbing');
      var index = $element.data('propertytab');
      if(event.shiftKey){
        var $nextElements = $('li[data-ratetab="'+ (index - 1)+'"] .js-tabbing');
       if($($allAnchors[$allAnchors.length - 1]).hasClass('no-link') || $allAnchors[0] === $(event.target)[0]) {
          if($($nextElements[0]).hasClass('no-link')) {
            $nextElements = $('li[data-propertytab="'+ (index-1) +'"] .js-tabbing');
          }
          if($nextElements.length) {
            event.preventDefault();
            $nextElements.focus();
          }
        }
      } else {
        var $nextElements = $('li[data-ratetab="'+ index +'"] .js-tabbing');
        if($allAnchors[$allAnchors.length - 1] === $(event.target)[0]) {
          if($($nextElements[0]).hasClass('no-link')) {
            $nextElements = $('li[data-propertytab="'+ (index + 1) +'"] .js-tabbing');
          }
          if($nextElements.length) {
            event.preventDefault();
            $nextElements[0].focus();
          }
        }
      }
    }
  },

  compareRateRateTabHandler: function _compareRateRateTabHandler(event) {
    if(event.which === 9) {
      var $element = $(event.currentTarget);
      var $allAnchors = $element.find('.js-tabbing');
      var index = $element.data('ratetab');
      if(event.shiftKey) {
        var $nextElements = $('li[data-propertytab="'+ (index) +'"] .js-tabbing');
        if($(event.target).hasClass('no-link') || $allAnchors[0] === $(event.target)[0]) {
          if($nextElements.length){
            event.preventDefault();
            $nextElements.focus();
          }
        }
      }else{
        var $nextElements = $('li[data-propertytab="'+ (index + 1) +'"] .js-tabbing');
        var isNextNoLink = $($allAnchors[$(event.target).closest('.l-compare-rate-container-item').index() + 1]).hasClass('no-link');
        if(isNextNoLink || $allAnchors[$allAnchors.length - 1] === $(event.target)[0]) {
          if($nextElements.length) {
            event.preventDefault();
            $nextElements[0].focus();
          }
        }
      }
    }
  },

  compareHotelTitleEllipsis: function() {
    var _self= this;
    _self.$el.find('.l-compare-hotel-name').dotdotdot({
      height: 52
    })
  },

  initCompareObj :  function(){
    var _self = this;
    _self.compareRateList.nextEl = _self.$el.find('.next');
    _self.compareRateList.previousEl = _self.$el.find('.previous');
    _self.compareRateList.rateHeaderAndArrowEl  =  _self.$el.find('.rate-label-inner-container, .hotel-name-inner-container, .arrow');
    _self.updateSize();

  },
  nextColumn : function(event){
    event.preventDefault();
    if($(event.currentTarget).hasClass('is-disable')){
      return;
    }
    var _self = this;
    if (_self.compareRateList.completedStep < _self.compareRateList.totalItem) {
      _self.compareRateList.nextEl.attr('aria-label', _self.$el.data('nextRateOnScreen'));
			_self.compareRateList.columnWidth = _self.compareRateList.columnWidth + _self.compareRateList.itemWidth
			if (_self.compareRateList.completedStep === _self.compareRateList.totalItem - 1 && _self.compareRateList.fraction > 0) {
				_self.compareRateList.columnWidth = _self.compareRateList.columnWidth - _self.compareRateList.fraction;
        _self.compareRateList.nextEl.addClass('is-disable');
        setTimeout(function() {
          _self.compareRateList.nextEl.attr('aria-label', _self.$el.data('scrollNextColumnLabel')+' '+_self.$el.data('unavailableLabel'));
        }, 500);
			}
			_self.compareRateList.completedStep = _self.compareRateList.completedStep + 1
      _self.updateLayout(_self.compareRateList.columnWidth);
			_self.compareRateList.previousEl.removeClass('is-disable').attr('aria-label', _self.$el.data('scrollPreviousColumnLabel'));
		}
  },
	 prevColumn : function(event) {
    event.preventDefault();
    if($(event.currentTarget).hasClass('is-disable')){
      return;
    }
    var _self = this;
		if (_self.compareRateList.completedStep > _self.compareRateList.initialCompleted && _self.compareRateList.completedStep <= _self.compareRateList.totalItem) {
      _self.compareRateList.previousEl.attr('aria-label', _self.$el.data('previousRateOnScreen'));
			_self.compareRateList.columnWidth = _self.compareRateList.columnWidth - _self.compareRateList.itemWidth
			if (_self.compareRateList.completedStep === _self.compareRateList.totalItem && _self.compareRateList.fraction > 0) {
				_self.compareRateList.columnWidth = _self.compareRateList.columnWidth + _self.compareRateList.fraction;
			}
			_self.compareRateList.completedStep = _self.compareRateList.completedStep - 1
      _self.updateLayout(_self.compareRateList.columnWidth);
			_self.compareRateList.nextEl.removeClass('is-disable');
			if (_self.compareRateList.completedStep == _self.compareRateList.initialCompleted) {
        _self.compareRateList.previousEl.addClass('is-disable');
        setTimeout(function() {
          _self.compareRateList.previousEl.attr('aria-label', _self.$el.data('scrollPreviousColumnLabel')+' '+_self.$el.data('unavailableLabel'));
        }, 500);
      }
      _self.compareRateList.nextEl.attr('aria-label', _self.$el.data('scrollNextColumnLabel'));
		}
	},

	updateSize : function() {
    var _self = this;
    _self.compareRateList.itemWidth = _self.$el.find('.l-compare-rate-container-item').outerWidth();
    _self.compareRateList.totalItem = 5;
    _self.compareRateList.columnWidth = 0,
    _self.compareRateList.compareWindowWidth = _self.$el.find('.js-compare-table').width(),
    _self.compareRateList.availableSpace = _self.compareRateList.compareWindowWidth - _self.$el.find('.hotel-name-container').outerWidth(),
    _self.compareRateList.initialCompleted = Math.trunc(parseFloat(Number(_self.compareRateList.availableSpace / _self.compareRateList.itemWidth).toFixed(2))),
    _self.compareRateList.completedStep = _self.compareRateList.initialCompleted,
    _self.compareRateList.fraction = _self.compareRateList.availableSpace - (_self.compareRateList.completedStep * _self.compareRateList.itemWidth);
    _self.compareRateList.compareContainerWidth = _self.$el.find(".compare-table .hotel-name-container").width() + _self.$el.find('.compare-table .rate-label-inner-container').width();
  },
  updateLayout : function (columnWidth) {
		this.$el.find(".comparison-inner-table, .rate-label-inner-container").css({
			'transform': 'translateX(-' + columnWidth + 'px)'
		});
  },
  hideCompareTab: function(){
    $('.js-toggle-view[name="map-tab"]').addClass('js-pill-view');
    $('.js-toggle-view[name="list-tab"]').addClass('js-pill-view');
  },
  checkWindowSize: function(){
    var _self = this;
    _self.updateViewOnWindoResize(_self.compareRateList.compareWindowWidth, _self.compareRateList.compareContainerWidth);
    _self.document_width = $(document).width();
    $(window).on('resize', function(){
      if(_self.document_width !== $(document).width()){
        _self.document_width = $(document).width();
        _self.updateSize();
        _self.updateViewOnWindoResize(_self.compareRateList.compareWindowWidth, _self.compareRateList.compareContainerWidth);
        _self.compareRateHeaderStickyHandler();
      }
    });    
  },

  checkWindowScroll: function(){
    var _self = this;
    // searchScrollPosition holds scroll position of search result page
    var searchScrollPosition = 50;
				$(window).on('scroll', function(){
						var scroll = $(window).scrollTop();
						if(scroll > searchScrollPosition && _self.responsiveUtils.isMobile()){
								$('.js-edit-search').addClass('hide-edit-button');
								$('.all-filter-btn').addClass('fixed-filter-position');
								$('.l-dates-scroll').attr("id","l-dates-v2");
								$('.tile-search-summary-scroll').addClass('tile-search-summary-v2');
								$('.l-label-scroll').addClass('hide-edit-button');
						}
						else {
								if(!$('.hide-suggested-filters').length) {
										$('.js-edit-search').removeClass('hide-edit-button');
										$('.all-filter-btn').removeClass('fixed-filter-position');
										$('.l-dates-scroll').attr("id","");
										$('.tile-search-summary-scroll').removeClass('tile-search-summary-v2');
										$('.l-label-scroll').removeClass('hide-edit-button');
								}
						}
				});
  },

  updateViewOnWindoResize: function(prevWindowWidth, prevCompareTableWidth){
    var _self = this;
		  var compareTableWidth = _self.$el.find(".js-compare-table").width();
    var diffInCompareTableWidth = Math.abs(prevCompareTableWidth - compareTableWidth);
    if (prevWindowWidth >= prevCompareTableWidth) {
			// Showing all columns since viewport is larger than the total content width of rates
      _self.updateLayout(0);
      _self.$el.find(_self.compareRateList.previousEl, _self.compareRateList.nextEl).addClass("disabled");
      _self.$el.find(".previous, .next").hide();
			return;
		} else {
      _self.$el.find(".previous, .next").show();
			if (prevWindowWidth < compareTableWidth) {
				var currentPos= _self.getCurrentPos(".rate-label-inner-container");
        var newPos = currentPos + diffInCompareTableWidth;
        if (newPos > 0) {
          newPos = 0;
        }
        _self.updateLayout(newPos);
			}
    }
  },
  getCurrentPos : function(ele){
    return(parseInt($(ele).css('-webkit-transform').split(/[()]/)[1].split(",")[4].trim()));
  },

  openSearchSummaryForm :  function(event){
    event.preventDefault();
    event.stopPropagation();
    this.pubsub.publish('OPEN_SEARCH_SUMMARY_FORM');

  },
  compareRateFixedHeader : function(){
    var _self = this;
    $(window).on('scroll', _self.compareRateHeaderStickyHandler.bind(_self));
  },
  compareRateHeaderHeight:  function(){
    var _self = this;
    if(_self.$el.find('.compare-table').length){
      setTimeout(function(){
        _self.compareRateHeaderStickyHandler();
      },500);
    }
  },
  compareRateHeaderStickyHandler : function() {
      var _self = this;
      var compareTable = _self.$el.find(".compare-table");
      var stickySummary = $("#stickySummary");
      var hotelNameContainer = _self.$el.find(".hotel-name-container");
      var comparisonInnerTable = _self.$el.find(".comparison-inner-table");
      var rateHeaderContainer = _self.$el.find(".rate-label-container");
      var rateHeaderContainerAndArrowEl = _self.$el.find(".rate-label-container,.arrow");
      var firstHotelNameContainer = _self.$el.find(".hotel-name-container .property-item").first().closest(".rate-label");
      var firstRateRow = comparisonInnerTable.find('.compare-rate').first();

      var stickySummaryHeight = stickySummary.height();
      var scrll = $(window).scrollTop();
      var compareTableOffsetTop = compareTable.offset().top - scrll;
      var hotelNameRightEnd = hotelNameContainer.offset().left + hotelNameContainer.outerWidth();
      var firstHotelNameContainerNewHeight = firstHotelNameContainer.height() + 1;
      var stickyEndLimit = (comparisonInnerTable.height() + (compareTable.offset().top - stickySummaryHeight));

      if (scrll < stickyEndLimit) {
        rateHeaderContainerAndArrowEl.removeClass("js-absolute");
        if (_self.$el.find(".compare-table.header-sticky").length === 0) {
          if (compareTableOffsetTop < stickySummaryHeight) {
            compareTable.addClass("header-sticky");
            rateHeaderContainerAndArrowEl.addClass("fixed").css({
              "top":stickySummaryHeight,
              "position":"",
              "bottom": "",
              "z-index":""
            }).show();
            rateHeaderContainer.width(comparisonInnerTable.width()).css("left", hotelNameRightEnd);
            firstHotelNameContainer.css("margin-top", firstHotelNameContainerNewHeight);
            firstRateRow.css("margin-top", firstHotelNameContainerNewHeight);
          } else {
            compareTable.removeClass("header-sticky");
            rateHeaderContainerAndArrowEl.removeClass("fixed").css("top", 0);
            rateHeaderContainer.css({
              "left" : "",
              "width" : ""
            });
            firstHotelNameContainer.css("margin-top", "");
            firstRateRow.css("margin-top", "");
          }
        } else {
          if (compareTableOffsetTop > stickySummaryHeight) {
            compareTable.removeClass("header-sticky");
            rateHeaderContainerAndArrowEl.removeClass("fixed").css("top", 0);
            rateHeaderContainer.css({
              "left" : "",
              "width" : ""
            });
            firstHotelNameContainer.css("margin-top", "");
            firstRateRow.css("margin-top", "");
          } else {
            rateHeaderContainerAndArrowEl.addClass("fixed").css({
              "top": stickySummaryHeight,
              "position": "",
              "bottom": "",
              "z-index": ""
            }).show();
            rateHeaderContainer.width(comparisonInnerTable.width()).css("left", hotelNameRightEnd);
            firstHotelNameContainer.css("margin-top", firstHotelNameContainerNewHeight);
            firstRateRow.css("margin-top", firstHotelNameContainerNewHeight);
          }
        }
      } else {
        var rateHeaderLeft = _self.$el.find(".comparison-table").position().left;
        rateHeaderContainerAndArrowEl.addClass("js-absolute").removeClass("fixed");
		    rateHeaderContainerAndArrowEl.css({
          "top": "",
          "position": "absolute",
          "left": ""
        });
        _self.$el.find(".rate-label-container")[0].style.setProperty("bottom", "0px", "important");
        _self.$el.find(".arrow")[0].style.setProperty("bottom", "0px", "important");
        _self.$el.find(".rate-label-container")[0].style.setProperty("left", rateHeaderLeft + "px", "important");
      }

      if ($(window).scrollTop() == 0) {
        compareTable.removeClass("header-sticky");
        rateHeaderContainerAndArrowEl.removeClass("fixed").css("top",0);
        rateHeaderContainer.css({
          "left" : "",
          "width" : ""
        });
        firstHotelNameContainer.css("margin-top", "");
        firstRateRow.css("margin-top", "");
      }
    },
   	/**
	 * Set Cookie for New Search(newUI)
	 */
  newUISearchCookie: function _newUISearchCookie() {
    var newMultiRate,
		multiRate;
		newMultiRate = $('.tile-property-records-toolbar').attr('data-new-multi-rate-experience');
		multiRate  = $('.tile-hsearch').attr('data-multi-rate-search');
     if(newMultiRate != undefined && multiRate != undefined && newMultiRate === "true" 
     && multiRate === "false"){
		    Cookies.createCookie('newSearch', 'newUI');
		}
	}, 
  /**
   * set DataLayer when path is new search
   */
  newSearchPath: function() {
   var newUI = Cookies.readCookie('newSearch');
   if(newUI != null && window.dataLayer ){
	window.dataLayer['search_res_path_type'] = "New Search without Multi-Rate";
    }
  },
  openRatesCalendar: function _openRatesCalendar(event) {
    event.preventDefault();
    var _self = this;
    var $element = _self.$el.find(event.currentTarget);
    var selectedPropertyItem = $element.closest('.js-property-record-item');
    var adfExpenderPropertyIndex = _self.$el.find('.js-property-record-item.adf-expanded').index();


    if(!selectedPropertyItem.hasClass('adf-expanded')) {
      _self.closeAdfRatesCalendar();
      $('html,body').addClass('adf-opened');
      
      var cloneAdfContainer = _self.$el.find('.js-wrapper + .adf-widget-loader-container').clone().addClass('adf-takeover');
      selectedPropertyItem.addClass('adf-expanded').append(cloneAdfContainer);
      var rateCategory = selectedPropertyItem.data('ratecategoryvalue');
      var openingDate = selectedPropertyItem.data('openingdate');
      var currency = selectedPropertyItem.data('currency');
      var url = $element.attr('href')+ '&propertyCurrency=' + (currency || '') + '&primaryRateType=' + (rateCategory || '') + '&months=[]&propertyOpeningSoonDate='+(openingDate || '') + '&fullPriceApplicable=' + _self.$el.data('fullpriceapplicable');
      _self.handleWidgetLoading(url);
      if(adfExpenderPropertyIndex > -1 && adfExpenderPropertyIndex < selectedPropertyItem.index()){
        $('html,body').scrollTop(selectedPropertyItem.offset().top - ($('.sticky-sub-section.is-sticky-top').height() || 0));
      }
    }
  },

  handleWidgetLoading: function _handleWidgetLoading(url) {
    //load new component
    var _self = this;
    var $layout = _self.$el.find('.adf-expanded .widget-content');
    var dataToSend = {};
    dataToSend.sessionToken = _self.getSessionToken();
    dataToSend.sourceURI = _self.getSourceURI();
    dataToSend.context = _self.getContextData();
    _self.loadedComponent = new Widget({
      hideSpinner: true,
      componentId: _self.$el.data('component-id'),
      layout: $layout,
      url: url + '&isMonthView=' + (!_self.responsiveUtils.isDesktop()) + '&isPropertyRecordsAvailabilityCalendar=true',
      sourceBlock: '.tile-availability-calendarV2',
      data: dataToSend,
      success: function() {},
      error: function() {
        $layout.addClass('isActive');
      }
    });
    
  },  

  closeAdfRatesCalendar: function _closeAdfRatesCalendar(event) {
    var _self = this;
    $('html,body').removeClass('adf-opened');
    _self.$el.find('.js-property-record-item').removeClass('adf-expanded').find('.adf-widget-loader-container').remove();
    if(event) {
      event.preventDefault();
      _self.$el.find(event.target).closest('.js-property-record-item').find('.js-view-rates-calendar').focus()
    }
  },
  hidePropertyCard: function(event) {

    var self = this;
    var listContainer = self.$el.find(".js-property-list-container");
    var pListContainer = self.$el.find(".js-list-container");
    var mapMarkerInfo = self.$el.find(".map-property-bubble");
    // if the target of the click isn't the container nor a descendant of the container
    if (this.responsiveUtils.isMobile() && self.isNewListMapViewEnabled) {
      if (!pListContainer.hasClass('hide-map-property-list') && !self.$el.find(event.target).hasClass('markerLabels')) 
      { 
        this.toggleTabSelection(true);
        listContainer.animate({
          left: "94%"
        }, 1000 );
        this.highlightPin(this.mapHandler.markers[this.$el.find('.in-focus').data('pnum')], Constants.PROPERTY_RECORD.MARKER_PIN_BLACK);
      }
    }  

    // closing of map marker infoWindow on outside click
    if($('.js-property-list-container').data('ismapclickpin')) {
      if(!this.responsiveUtils.isMobile() && mapMarkerInfo.length > 0){
        if(this.mapHandler && this.mapHandler.infoWindow){
          this.mapHandler.infoWindow.close();
          if (this.lastMarker && this.mapClickPinColorflag) {
            this.hidePropertyRecordInfoOnMarker(this.lastMarker, this.mapHandler.infoWindow);
          }
        }
      }
    }
  },
  /**
   * Set search result position data layer
   */   
  setSearchResultPositionDataLayer: function(){ 
    var _self = this;
    var pageNo = dataLayer.search_list_page_current;
    var recordsPerPage = dataLayer.search_list_records_on_page;
    var pipeLine ="|";
    var selectedRatePosition, search_result_position_selected;

    var nodes = $(".js-property-list-container .js-button-text-wrapper");
     for (var i = 0; i < nodes.length; i++) {
          nodes[i].addEventListener('click', function(i) {
	 selectedRatePosition = i+1;
         var ordinalSuffix= _self.ordinalSuffixOf(selectedRatePosition); 
	 if(pageNo != undefined && recordsPerPage != undefined){
	    search_result_position_selected = "page "+pageNo+pipeLine+recordsPerPage+" results per page"+pipeLine+ordinalSuffix+" selected";
	    sessionStorage.setItem("search_result_position_selected", search_result_position_selected);
	  }
      }.bind(null, i));
    }
  },
  ordinalSuffixOf : function(n){
   return n + (n > 0 ? ['th', 'st', 'nd', 'rd'][(n > 3 && n < 21) || n % 10 > 3 ? 0 : n % 10] : '');
  },
  hideMapPropertyRecordsList: function _hideMapPropertyRecordsList(event) {
    event.stopPropagation() && event.preventDefault();
    this.toggleTabSelection(true);
    this.$el.find('.js-list-container').addClass('hide-map-property-list');
    this.highlightPin(this.mapHandler.markers[this.$el.find('.in-focus').data('pnum')], Constants.PROPERTY_RECORD.MARKER_PIN_BLACK);
  },
  isPropertyRecordsHidden: function() {
    return this.$el.find('.hide-map-property-list').length ? true : false;
  },
  isGroupSearchActive: function(){
    return this.$el.hasClass('tile-property-records-group-search');
  },
  /**
   * Set search results view data layer
   */
  setSearchResultViewDataLayer: function(){
   if(window.dataLayer){
    var searchResultView;
    var search_currency_type = window.dataLayer.search_currency_type;
      if(search_currency_type != undefined && search_currency_type == "Default"){
       	if($('.rate-block .price-night .t-font-xs').length > 0){
              window.dataLayer['search_currency_type'] = $('.rate-block .price-night .t-font-xs').text().trim().slice(0, 3);
        }else if($('.l-special-rates-selected .rate-block .t-font-xs').length > 0){
	        window.dataLayer['search_currency_type'] = $('.l-special-rates-selected .rate-block .t-font-xs').text().trim().slice(0, 3);     
	 }
      }
      searchResultView = $('.tile-property-records-toolbar .js-toggle-view.is-hidden').attr('title') || 
      $('.tile-property-records-toolbar .l-multi-rate-button.is-active').attr('title');
	if(searchResultView != undefined){
	    window.dataLayer['search_results_view'] = searchResultView;
        }
    }	
  },
  toggleTabSelection(toggleState){
    var _self = this;
    var currentTabSelection = $('.js-toggle-view[data-view="list"]');
    var hideCardButton = _self.$el.find(".m-map-page-nation");
    if(_self.isNewListMapViewEnabled && _self.responsiveUtils.isMobile()){
      if(toggleState){
        currentTabSelection.show();
        hideCardButton.hide();
      }else{
        currentTabSelection.hide();
        hideCardButton.show();
      }
    }
  },

  /**
   * Initialize Gallery on property based on the images availabilty
   */
  initGalleryOnProperty: function(){
    var _self = this;

    // Hiding carousel if it is mobile/tablet device
    if(_self.responsiveUtils.isMobileOrTablet()) {
      $('.mi-carousel.property-image-gallery').remove();
    }

    // Showing slick arrows on ipad device
    if (_self.responsiveUtils.isDevice()) {
      $('.mi-carousel.property-image-gallery').find('.slick-arrow').addClass('m-tab-arrow-visible');
    } 
  },

  /**
   * This method is used to show hotel info on map view on hover of property.
   * @param {Object} event Is the event object passed.
   */
  infoWindowOnMouseEnter: function(event) {
    if (this.isMapView) {
      var mapMarkerInfo = this.$el.find(".map-property-bubble");
      var infoWindowOpen = $(event.target).closest('.map-property-bubble').length;
      var markerIndex = $(event.target).closest('.js-property-record-item').data('pnum');
      var mapMarker = this.mapHandler.markers[markerIndex];
      if (!mapMarker && this.mapHandler && this.mapHandler.duplicateMarkers.length) {
        this.mapHandler.duplicateMarkers.forEach(function(duplicateMarker) {
          if(duplicateMarker.markerIndex.indexOf(markerIndex) > -1) {
            mapMarker = duplicateMarker;
          }
        });
      }
      if(!infoWindowOpen && $('.js-property-list-container').data('ismapclickpin') && this.isMapView && !this.responsiveUtils.isMobile()) {
        if(mapMarkerInfo.length > 0){
          this.hidePropertyRecordInfoOnMarker(mapMarker, this.mapHandler.infoWindow);
        }
        if (this.lastMarker && this.mapClickPinColorflag) {
          this.hidePropertyRecordInfoOnMarker(this.lastMarker, this.mapHandler.infoWindow);
        }
        this.showPropertyRecordInfoOnMarker(mapMarker, this.mapHandler.infoWindow);
        this.mapClickPinColorflag = true;
      }
    }
  },

  /**
   * open modal window if mapClickPin flag is true
   */
  openInfoWindowModal: function(event){
    var mapMarkerInfo = this.$el.find(".map-property-bubble");
    var markerArrayIndex = this.lastMarker ? this.lastMarker.markerIndex : '';
    if($('.js-property-list-container').data('ismapclickpin')) {
      if(!this.responsiveUtils.isMobile() && mapMarkerInfo.length > 0){
        if (this.options.isDestinationPage) {
          this.deHighlightPins();
          if(this.mapHandler && this.mapHandler.infoWindow){
            this.mapHandler.infoWindow.close();
            this.showPropertyRecordInfoOnMarker(marker, this.mapHandler.infoWindow);
          }
        } else {
          this.mapClickPinColorflag = false;
          this.onPropertyPinSelected(this.lastMarker, markerArrayIndex);
        }
        event.preventDefault();
      }
    }
  },

  /**
   * shows brand drawer section
   */
  openBrandDrawerSection: function(event){
    if(event.which === 13 || event.type === 'click') {
      $(event.target).closest('.brand-text-container').hide();
      $(event.target).closest('.brand-drawer-container').find('.brand-content-container').show();
    }
  },

  /**
   * hides brand drawer section
   */
  closeBrandDrawerSection: function(event){
    if(event.which === 13 || event.type === 'click') {
      $(event.target).closest('.brand-drawer-container').find('.brand-text-container').show();
      $(event.target).closest('.brand-content-container').hide();
    }
  },

  /**
   * open mandatory fee popup
   */
  openMandatoryFeeModal: function(event){
    if(event.which === 13 || event.type === 'click') {
      var mandatoryFeeTitle = $(event.target).data('mtitle');
      var mandatoryFeeSubTitle = $(event.target).data('include');
      var mandatoryFeeDescription = $(event.target).data('mandatory');
      // var mandatoryFeeDescription = 'A daily destination fee of USD 35 will be added to the room rate and includes complimentary local, long distance and international calls, one SoulCycle class, USD 35 food and beverage credit excluding Cabaret, USD 50 laundry cleaning credit and 25 percent off SMores & Sweet Personalization at Hersheys Chocolate World Times Square. All credits are per room per day and cannot be accumulated.';
      var mandatoryFeeList = [];
      if ( mandatoryFeeDescription.length ) {
        mandatoryFeeList = mandatoryFeeDescription.split('|');
      }
      mandatoryFeePopup = new Popup({
        selector: '.mandatory-fee-pop-up-box',
        alternateCloseMarkup: true,
        sourceBlock: '.modal-content',
        items: {
          type: 'inline',
          src: '<div class="mandatory-fee-container"><h3 class="mandatory-fee-heading">'+mandatoryFeeTitle+'</h3><div class="mandatory-fee-content"><div class="mandatory-fee-subheading">'+ mandatoryFeeSubTitle +':</div><ul class="mandatory-fee-list"></div><div class="mandatory-fee-button"></div></div>'
        }
      });
      mandatoryFeePopup.register();
      mandatoryFeePopup.openPopup();
      $.each(mandatoryFeeList, function(index, listItem) {
        $('.mandatory-fee-container .mandatory-fee-list').append('<li><span>'+listItem+'</span></li>')
      });
      var btnEle = $(event.target).parents('.js-button-text-wrapper').find('.js-view-rate-btn-link').eq(1).clone();
      $('.mandatory-fee-button').append(btnEle);
      $('.mfp-close').text('');
      $('.mfp-content').addClass('mandatory-modal-content');
    }
  }
});
